export default {
  satelliteReport: {
    satelliteReport: "Ripoti za Satellite",
    generateReport: "Jenga Ripoti Mpya",
    satelliteReportTooltip:
      "Hapa unaweza kupata ripoti 5 za msingi za satelaiti kwa mashamba yako (NDVI, MSAVI, NDRE, RECI, LSWI) ili kutathmini afya ya mazao kulingana na viwango vya virutubishi na unyevu",
    operatorName: "Jina la Mwendeshaji",
    issueDate: "Tarehe ya Kutolewa",
    selectFarm: "Chagua Shamba",
    chooseFarm: "Chagua Shamba",
    chooseZone: "Chagua Eneo",
    genReport: "Jenga Ripoti",
    viewReport: "Tazama Ripoti",
    farmName: "Jina la Shamba",
    allFarms: "Mashamba Yote",
    zone: "Eneo(la)",
    selectReportType: "Chagua Aina ya Ripoti",
    report: "Ripoti",
    cropHealth: "Afya ya Mazao (NDVI)",
    doi: "Tarehe ya Kuvutia",
    dateOfImage: "Tarehe ya Picha yenye Kufunika Mawingu Kidogo",
    reciValues: "Thamani za RECI Zinafikia Kutoka 0 hadi 10",
    ndviValues: "Thamani za NDVI",
    rangeSubtitle: "Thamani karibu na 1 inaashiria mimea yenye afya",
  },
  deforestation: {
    riskLevel: "Hatari",
    producerData: {
      addProducers: "ONGEZA MZALISHAJI MPYA",
      countryInfo:
        "Sehemu ya kuingiza au kuonyesha nchi inayohusiana na mtayarishaji.",
    },
    selectFileToUpload: "Chagua faili kupakia data",
    uploadedToEU: "Imepakiwa kwenye Portal ya EU",
    pending: "Inasubiri",
    underReview: "Inakaguliwa",
    compliant: "Inakubaliana",
    nonCompliant: "Haiendani",
    analyzeDeforestation: "Inachambua Ukataji Miti",
    analyzingDeforestation: "Inachambua Ukataji Miti",
    readyToProceed: "Tayari Kuendelea",
    processingFarm: "Inachakata Shamba",
    mitigationRequired: "Inahitajika Upunguzaji Athari",
    pendingApproval: "Inasubiri Idhini",

    veryHighDeforestationProbability: "Uwezekano wa Ukataji Miti Ulio Juu Sana",
    highDeforestationProbability: "Uwezekano wa Ukataji Miti Ulio Juu",
    mediumDeforestationProbability: "Uwezekano wa Ukataji Miti wa Kati",
    lowDeforestationProbability: "Uwezekano wa Ukataji Miti Ulio Chini",
    veryLowDeforestationProbability:
      "Uwezekano wa Ukataji Miti Ulio Chini Sana",
    zeroNegligibleDeforestationProbability:
      "Uwezekano wa Ukataji Miti wa Sifuri/Hauna Athari",
    manuallyMitigated: "Umejumuishwa kwa Mikono",

    selectCountry: "Chagua Nchi",
    internalReferenceNumberMustBeAlphanumeric:
      "Nambari ya kumbukumbu ya ndani inapaswa kuwa ya herufi na nambari",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired:
      "Angalau moja kati ya kitambulisho cha muuzaji au jina la muuzaji kinahitajika",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired:
      "Angalau moja kati ya kitambulisho cha mwendeshaji au jina la mwendeshaji kinahitajika",
    netMassIsRequired: "Uzito halisi unahitajika",
    netMassMustBeValid: "Uzito halisi lazima uwe sahihi",
    thisFieldIsRequired: "Sehemu hii ni ya lazima",
    volumeMustBeNumeric: "Kiasi kinapaswa kuwa cha nambari",
    nameIsRequired: "Jina linahitajika",
    firstNameIsRequired: "Jina la Kwanza linahitajika",
    countryIsRequired: "Nchi inahitajika",
    lastNameIsRequired: "Jina la Mwisho linahitajika",
    confirmPdfDownload: "Unataka kupakua viambatisho vyote kwa muundo wa PDF?",
    confirmJsonDownload:
      "Unataka kupakua viambatisho vyote kwa muundo wa JSON?",
    basicFinalFarmListWithStatus:
      "Orodha ya mashamba ya mwisho ya msingi na hali",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities:
      "Taarifa za kina, zikiwemo maelezo ya shughuli za kupunguza hatari",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments:
      "Hati kamili, ikiwemo kupunguza hatari na nyaraka zilizoambatanishwa",

    existing: "Iliyopo",
    survey: "Utafiti",

    operatorInformation: "Taarifa za Mwendeshaji",
    addNewOperator: "Ongeza Mwendeshaji Mpya",

    reportAddedSuccessfully: "Ripoti imeongezwa kwa mafanikio",
    reportUpdatedSuccessfully: "Ripoti imesasishwa kwa mafanikio",
    itemDeletedSuccessfully: "Kipengee kimefutwa kwa mafanikio",
    reportDeletedSuccessfully: "Ripoti imefutwa kwa mafanikio",
    anErrorOccurredWhileDeletingTheReport:
      "Hitilafu imetokea wakati wa kufuta ripoti",

    valueMustBeBetween02And40: "Thamani inapaswa kuwa kati ya 0.2 na 40",

    EUDRDeforestationStatusTT:
      "Uchaguzi wa hali ya ukataji miti. Uwezekano mkubwa wa Ukataji Miti: Jamii maalum ya tathmini ya hatari inayotolewa kwa maeneo ya kijiografia kulingana na uwezekano wa ukataji miti au uharibifu wa misitu. Hii husaidia kuamua mahitaji ya bidii kwa waendeshaji wanaoleta sokoni bidhaa muhimu (kama vile kakao, kahawa, n.k.) au bidhaa zinazotokana nazo. Uwezekano mdogo wa Ukataji Miti: Jamii ya tathmini ya hatari inayotolewa kwa maeneo ya kijiografia yanayozingatiwa kuwa na uwezekano mdogo wa ukataji miti mkubwa. Uwezekano wa Ukataji Miti Usiokuwepo/Hafifu: Uwezekano mdogo au usiokuwepo kabisa wa kutokea kwa ukataji miti.",

    complianceRiskWarnings: "Onyo za Hatari ya Uzingatiaji",
    complianceRiskWarningsInfo:
      "Inaonyesha kichwa cha sehemu, ikionyesha kuwa eneo hili linaangazia maonyo yanayohusiana na hatari za kufuata taratibu katika mchakato wa uangalizi wa kina.",
    locationVerificationTT:
      "Inahusu mchakato wa kuthibitisha na kuhakiki eneo la kijiografia la maeneo ya uzalishaji kama sehemu ya taratibu za bidii. Inahusisha kuhakikisha kuwa maelezo ya eneo yaliyotolewa, kama vile kuratibu au anwani, yanaakisi kwa usahihi eneo halisi la shughuli za uzalishaji. Uthibitishaji huu ni muhimu kutathmini athari za mazingira, uzingatiaji wa matumizi ya ardhi na usahihi wa data zilizoripotiwa ndani ya ripoti ya bidii.",
    netMassKg: "Uzito Halisi (kg)",
    volumeM3: "Kiasi (m3)",
    warning: "Onyo",

    productionPlacesTT: "Maeneo ambapo bidhaa zinatengenezwa au kupandwa.",
    productionPlacesCountryInfo:
      "Mwili wa kijiografia ulio tofauti na una serikali yake na mipaka.",
    productionPlacesProducersInfo:
      "Chombo kinachohusika na kutengeneza au kukuza bidhaa.",
    totalsTT:
      "Sehemu ya 'Jumla' inatoa muhtasari wa viashiria kuu vya kiasi kwa seti nzima ya data au ripoti. Inajumlisha data kutoa mtazamo wa haraka wa vipimo vya jumla kama vile jumla ya uzito wa bidhaa, jumla ya kiasi cha bidhaa, eneo la eneo la uzalishaji, n.k. zilizojumuishwa katika ripoti ya bidii.",

    AnalysisOfDeforestationStatusTT:
      "Uchambuzi wa hali ya sasa ya ukataji miti ndani ya eneo fulani, kawaida hufanywa ili kutathmini athari za mazingira au uzingatiaji wa juhudi za uhifadhi.",

    complete: "Imekamilika",

    undoDelete: "Futa Kufuta",

    verifyingLocationsData: "Kukagua data za eneo...",
    crossCheckingWithProductionPlaces: "Kukagua na maeneo ya uzalishaji...",
    almostTherePleaseHoldOn: "Karibu tayari, tafadhali subiri...",
    LocationVerifiedSuccessfully: "Eneo limethibitishwa kwa mafanikio!",
    allProductionPlacesAndLocationsHaveBeenConfirmed:
      "Maeneo yote ya uzalishaji na maeneo yamehakikishwa!",
    errorCheckingOverlaps: "Hitilafu katika kukagua mchanganyiko.",
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon:
      "Shamba ni kubwa zaidi ya ekari 4, linahitaji kuwa poligoni",
    failedToFetchSettings: "Imeshindwa kupata mipangilio",
    farmCountryNotDefined: "Nchi ya shamba haijafafanuliwa.",
    theGeofencesSupposeToBeIn: "Geofence inapaswa kuwa ndani",
    butItsIn: "lakini ipo ndani ya",
    geofenceIsInOcean: "Geofence au sehemu yake iko baharini.",

    existingReport: "Ripoti ya Ukataji Miti Iliyopo",
    dimitraReport: "Ripoti ya Ukataji Miti ya Dimitra",
    oneForAllFarms: "Moja kwa Mashamba Yote",
    oneForEachFarm: "Moja kwa Kila Shamba",
    anErrorOccuredWhileFetchingTheDeforestationReport:
      "Hitilafu imetokea wakati wa kuchukua ripoti ya ukataji miti.",

    attachRiskMigrationDocTT:
      "Inahusu kitendo cha kuambatanisha au kuhusisha hati moja kwa mashamba yote yaliyotambuliwa kuwa na hatari ya ukataji miti, kawaida kwa madhumuni ya kuandika au uzingatiaji wa sheria.",
    eudrComplianceStatus: "Hali ya Utekelezaji wa EUDR",
    deforestationComplianceReport: "Ripoti za Utekelezaji wa Ukataji Miti",
    noDeforestationComplianceReport:
      "Hakuna Ripoti ya Utekelezaji wa Ukataji Mit iIliyopatikana",
    loadingDeforestationComplianceReport:
      "Inapakia Ripoti ya Utekelezaji wa Ukataji Miti",
    farmName: "Jina la Shamba",
    farmRegistrationId: "ID ya Usajili wa Shamba",
    farmerName: "Jina la Mkulima",
    farmerRegistrationId: "ID ya Usajili wa Mkulima",
    uniqueFarmerId: "ID ya Kipekee ya Mkulima",
    uniqueFarmId: "ID ya Kipekee ya Shamba",
    farmLocation: "Eneo la Shamba",
    area: "Eneo",
    farmAddress: "Anwani ya Shamba",
    dateOfRequest: "Tarehe ya Ombi",
    status: "Hali",
    settings: "Mipangilio",

    farmLatitude: "Latitude ya Shamba",
    farmLongitude: "Longitude ya Shamba",
    shareQRCode: "Shiriki Msimbo wa QR",
    copy: "Nakili",

    allCountries: "Nchi Zote",
    allRegions: "Mikoa Yote",
    allFarms: "Mashamba Yote",
    viewCertificate: "Angalia Cheti",

    assignmentIssued: "Makazi Yaliyotolewa",

    complianceCertification: "Cheti cha Utekelezaji",
    noComplianceCertification: "Hakuna Cheti cha Utekelezaji Kilichopatikana",
    loadingComplianceCertification: "Inapakia Cheti cha Utekelezaji",

    eudrForestAssessment: "Ukadiriaji wa Misitu ya EUDR",
    assessmentReport: "Ripoti ya Tathmini",
    downloadPDF: "Pakua PDF",
    back: "Nyuma",
    farmDetails: "Maelezo ya Shamba",

    dimitraFarmId: "ID ya Shamba la Dimitra",
    dimitraFermerId: "ID ya Mkulima wa Dimitra",

    totalGeofenceAreaHA: "Jumla ya Eneo la Geofensi (HA)",
    forestLossHA: "Upotezaji wa Msitu (HA)",
    forestGainHA: "Faida ya Msitu (HA)",
    forestUnchangedHA: "Msitu Usiobadilika (HA)",
    shareCertificate: "Shiriki Cheti",
    forestUnchanged: "Msitu Usiobadilika",
    forestLoss: "Upotezaji wa Msitu",
    forestGain: "Faida ya Msitu",
    totalGeofenceArea: "Jumla ya Eneo la Geofensi",
    deforestationProbability: "Uwezekano wa Ukataji Miti",
    colorCode: "Msimbo wa Rangi",
    geofenceArea: "Eneo la Geofensi",
    percentageOfGeofenceArea: "Asilimia ya Eneo la Geofensi",
    view: "Tazama",
    customization: "Ubinafsishaji",
    recordsPerpage: "Rekodi kwa Ukurasa",
    restoreDefault: "Rejesha Mipangilio ya Awali",
    apply: "Tumia",
    forestAssessmentHelp:
      "Ikiwa una maswali juu ya ripoti hii au unahitaji msaada wa kuielewa, wasiliana nasi kupitia Duka la Msaada.",
    overallDeforestationProbability: "Uwezekano Mkuu wa Ukataji Miti",
    zeroOrNegligible: "Sifuri/Isiyokuwa na Maana",
    high: "Ju",
    allStatus: "Hali Zote",
    low: "Chini",
    veryHigh: "Sana Juu",
    medium: "Kati",
    veryLow: "Sana Chini",
    assessmentIssued: "Tathmini Iliyotolewa",
    certificateIssued: "Cheti Kilichotolewa",
    assessmentNo: "Nambari ya Tathmini",
    blockchainCertificateDesc:
      "Hash ya Uthibitisho wa Cheti cha Blockchain itapatikana baada ya kukubaliwa kwa cheti",
    blockchainValidation: "Uthibitisho wa Cheti cha Blockchain",
    openBlockchainPage: "Fungua Ukurasa wa Blockchain",
    clickLinkDesc:
      "Bonyeza kwenye kiungo hapo juu kwa ajili ya kuthibitisha cheti kwenye blockchain",
    "Zero/Negligible Deforestation Probability":
      "Uwezekano wa Ukataji Miti Sifuri/Usio na Athari",
    "Zero Deforestation Probability": "Uwezekano wa Ukataji Miti Sifuri",
    "Low Deforestation Probability": "Uwezekano wa Ukataji Miti Mdogo",
    "High Deforestation Probability": "Uwezekano wa Ukataji Miti Mkubwa",
    "Very Low Deforestation Probability":
      "Uwezekano wa Ukataji Miti Mdogo Sana",
    "Medium Deforestation Probability": "Uwezekano wa Ukataji Miti Wastani",
    "Very High Deforestation Probability":
      "Uwezekano wa Ukataji Miti Mkubwa Sana",
    disputeReason: "Sababu ya Mgogoro",
    disputeStatus: "Hali ya Mgogoro",
    farmRegId: "ID ya Usajili wa Shamba",
    productionPlaceId: "ID ya Eneo la Uzalishaji",
    disputeId: "ID ya Mgogoro",
    disputeArea: "Ukubwa wa Eneo",
    disputeResolution: "Utatuzi wa Mgogoro",
    selectDefaultMeasurementUnit: "Chagua Vitengo vya Kipimo vya Kawaida",
    selectDefaultMeasurementUnitInfo:
      "Inaruhusu kuchagua vitengo vya kipimo vya chaguomsingi, ikiwa ni pamoja na kubainisha kitengo, kuweka kikomo cha juu, na kukifanya kuwa chaguo la chaguomsingi.",
    maxLimit: "Kikomo cha Juu",
    maxLimitInfo:
      "Huweka thamani ya juu zaidi inayoruhusiwa au kizingiti kwa kipimo fulani.",
    asDefault: "Weka kama Kawaida",
    productMass: "Uzito wa Bidhaa",
    productMassUnitInfo: "Inaeleza kitengo cha kupimia uzito wa bidhaa.",
    volumeUnitInfo: "Inaeleza kitengo cha kupimia kiasi cha bidhaa.",
    operatorInfo:
      "Inahusu mtu au taasisi inayosimamia au kuendesha mfumo au mchakato.",
    supplierInfo: "Taasisi inayotoa bidhaa au huduma kwa taasisi nyingine.",
    userTypeInfo:
      "Inapanga watu au taasisi kulingana na jukumu lao au ruhusa zao ndani ya mfumo.",
    unit: "Kipimo",
    userType: "Aina ya Mtumiaji",
    eudrPortalApiKeys: "Vifunguo vya API vya EUDR Portal",
    apiKey: "Kifunguo cha API",
    apiSecret: "Siri ya API",

    assessmentRiskMitigationLvl:
      "Viwango vya Utekelezaji wa Hatari ya Tathmini",
    assessmentRiskMitigationLvlInfo:
      "Inagawanya ukali wa hatari zinazohusiana na matumizi ya ardhi, mbinu za upanzi wa misitu, na upanuzi wa kilimo. Viwango hivi husaidia kubaini athari zinazoweza kutokea za shughuli katika maeneo ya misitu na kutoa mwelekeo wa hatua zinazofaa kupunguza madhara mabaya. Inagawanya viwango vya mikakati ya kupunguza hatari, ikiwa ni pamoja na kiwango cha juu sana, cha juu, cha kati, cha chini, na sifuri/kidogo.",

    dynamicExpiryTime: "Muda wa Kumalizika kwa Muda Uliobadilika",
    dynamicExpiryTimeInfo:
      "Huweka kipindi cha muda baada ya ambayo data au mipangilio fulani inakuwa haifai kiotomatiki. Inapanga mipangilio inayohusiana na ripoti za upunguzaji wa misitu, ikiwa ni pamoja na chaguzi za upya wa kiotomatiki.",
    eudrDeforestationAssessment: "Tathmini ya Ukataji Miti wa EUDR",
    autoRenewalIf:
      "Upyaji wa Moja kwa Moja Unapoongezwa kwa Ripoti ya Uadilifu",
    declarationStatements: "Kauli za Tamko",
    declarationStatementsInfo:
      "Taarifa zinazotolewa na upande unaohusika kuthibitisha usahihi, ukamilifu, na uhalisia wa taarifa zilizo katika ripoti.",
    filterDeclaration: "Chuja Kauli za Tamko",
    declarationTitle: "Kichwa cha Tamko",
    declarationTitleInfo:
      "Kichwa au heading cha taarifa ya tamko, kinachotoa muktadha au kufupisha maudhui yake.",
    applicableCountry: "Nchi Zinazotumika",
    applicableCountryInfo:
      "Inataja nchi ambazo mipangilio au kanuni fulani zinahusiana.",
    addMore: "Ongeza Zaidi",
    autoRenewal: "Upyaji wa Moja kwa Moja",
    createNewAssessment: "Unda Tathmini Mpya",
    userDimitraAssessment: "Tumia Tathmini za Dimitra",
    shipmentList: "Orodha ya Usafirishaji",
    generalData: "Data za Kawaida",
    check: "Angalia",
    allProducer: "Watayarishaji Wote",
    very_high: "Kubwa Sana",
    very_low: "Ndogo Sana",
    tooltip: {
      dimitraFarmId:
        "Kitambulisho kipekee kilichounganishwa na shamba fulani katika mfumo wa Dimitra.",
      farmName: "Jina lililoteuliwa la shamba.",
      farmRegistrationId: "Nambari ya usajili wa shamba.",
      farmLocation: "Ukurasa maalum wa kijiografia au eneo la shamba.",
      dimitraFermerId:
        "Kitambulisho cha kipekee kilichounganishwa na mkulima binafsi ndani ya mfumo wa Dimitra.",
      farmerName: "Kitambulisho cha mtu anayewajibika kwa shamba.",
      farmerRegistrationId: "Nambari ya usajili ya mkulima.",
      assessmentNo: "Nambari ya kipekee iliyopewa tathmini.",
    },
    red: "Nyekundu",
    Yellow: "Manjano",
    transparent: "Wazi",
    darkRed: "Nyekundu Giza",
    brightRed: "Nyekundu Ya Kung'aa",
    orange: "Chungwa",
    lightBlue: "Bluu Lepesi",
    teal: "Teal",
    zeroOrNegligibleProbability:
      "Uwezekano wa Ukataji Miti Sifuri/Isiyokuwa na Maana",
    riskDetected: "Hatari Imegunduliwa",
    zeroOrNegligibleRisk: "Hatari ya Sifuri/Ndogo Sana",
    veryLowProbability: "Uwezekano Mdogo Sana wa Ukataji Miti",
    lowProbability: "Uwezekano Mdogo wa Ukataji Miti",
    mediumProbability: "Uwezekano wa Kati wa Ukataji Miti",
    highProbability: "Uwezekano Mkubwa wa Ukataji Miti",
    veryHighProbability: "Uwezekano Mdogo Sana wa Ukataji Miti",
    locationName: "Jina la Mahali",
    zeroOrNeglegible: "Sifuri au Ndogo sana",
    Red: "Nyekundu",
    Transparent: "Wazi",
    zeroOrNeglegibleProbability:
      "Uwezekano wa Ukataji miti Sifuri/Ambao Hautilii Maanani",
    approve: "Idhinisha",
    conclude: "Hapana",
    approveMessage:
      "Je, una uhakika unataka kuidhinisha ripoti hii? Baada ya kuidhinisha ripoti ya mwisho, hakuna masasisho zaidi yanayoweza kufanywa kwenye ripoti.",
    dueDeligence: "Uzito wa Kufanya",
    supplierInformation: "Maelezo ya Muuzaji",
    addNewSupplier: "Ongeza Muuzaji Mpya",
    name: "Jina",
    lastName: "Jina la Mwisho",
    email: "Barua pepe",
    phoneNumber: "Nambari ya Simu",
    enterSupplierName: "Ingiza Jina la Muuzaji",
    enterSupplierLastName: "Ingiza Jina la Mwisho la Muuzaji",
    enterSupplierFirstName: "Ingiza Jina la Kwanza la Muuzaji",
    enterOperatorName: "Ingiza Jina la Mwendeshaji",
    enterEmailAddress: "Ingiza Anwani ya Barua pepe",
    enterPhoneNumber: "Ingiza Nambari ya Simu",
    whoWillAddPlace: "Nani Ataongeza Mahali ya Uzalishaji?",
    companyId: "ID ya Kampuni",
    activity: "Shughuli",
    placeOfActivity: "Mahali pa Shughuli",
    countryOfActivity: "Nchi ya Shughuli",
    operatorPlaceOfActivity: "Mahali pa Shughuli ya Mwajiri",
    operatorCountryOfActivity: "Nchi ya Shughuli ya Mwajiri",
    countryOfEntry: "Nchi ya Kuingia",
    productDetail: "Maelezo ya Bidhaa",
    subProduct: "Bidhaa Ndogo",
    productionDescription: "Maelezo ya Uzalishaji",
    netMass: "Misa ya Neti",
    volume: "Kiasi",
    scientificName: "Jina la Kisayansi",
    commonName: "Jina la Kawaida",
    eudrDueDeligenceReports: "Ripoti za Uzito wa Kufanya wa EUDR",
    EUDRAssessmentReport: "Ripoti ya Tathmini ya EUDR",
    createNewReport: "Unda Ripoti Mpya",
    eudrRefNo: "Nambari ya Kumbukumbu ya EUDR",
    eudrRefNoInfo:
      "Kipengele cha kupata taarifa maalum zinazohusiana na usafirishaji.",
    statusInfo:
      "Hali ya sasa ya usafirishaji kuhusiana na ripoti ya uchunguzi wa kina.",
    eudrAndInternalRefNo: "Nambari ya Kumbukumbu ya EUDR / Ndani",
    exporterAndSupplier: "Mzalishaji & Muuzaji",
    internalRefNo: "Nambari ya Kumbukumbu ya Ndani",
    supplier: "Muuzaji",
    quantity: "Kiasi",
    product: "Bidhaa",
    noOfFarms: "Idadi ya Mashamba",
    farmsAndQuantity: "Mashamba na Kiasi",
    country: "Nchi",
    lastUpdated: "Sasisho la mwisho",
    dueDeligenceStatus: "Hali ya Uzito wa Kufanya",
    edurDueDeligenceStatus: "Hali ya Uzito wa Kufanya wa EUDR",
    reject: "Kataa",
    discard: "Tupa",
    saveAndContinueLater: "Hifadhi na Endelea Baadaye",
    requestAdditionalInformation: "Omba Taarifa Zaidi",
    requestAdditionalInformationShort: "Omba maelezo zaidi",
    uploadToEudr: "Pakia kwenye EUDR",
    productionPlaces: "Maeneo ya Uzalishaji",
    next: "Next",
    dueDeligenceReportCreation: "Uundaji wa Ripoti ya Uzito wa Kufanya",
    producer: "Mzalishaji",
    select: "Chagua",
    productionPlacesFarmAndFarmId:
      "Mahali ya Uzalishaji (Shamba) & ID ya Shamba",
    producerName: "Jina la Mzalishaji",
    addressOfProduction: "Anwani ya Uzalishaji",
    type: "Aina",
    geofence: "Geofensi",
    areaHa: "Eneo (ha)",
    editGeofence: "Hariri Geofensi",
    totals: "Jumla",
    locationVerification: "Uhakiki wa Mahali",
    AnalysisOfDeforestationStatus: "Uchambuzi wa Hali ya Kukata Mitini",
    EUDRDeforestationStatus: "Hali ya Ukatili wa Mitini wa EUDR",
    removeAllLowRiskFarm: "Ondoa Mashamba Yote ya Hatari Ndogo",
    removeAllHighRiskFarm: "Ondoa Mashamba Yote ya Hatari Kubwa",
    removeAllMediumRiskFarm: "Ondoa Mashamba Yote ya Hatari ya Kati",
    attachRiskMigrationDoc:
      "Ambatanisha hati moja ya kupunguza hatari kwa mashamba yote yenye hatari kubwa",
    removedFarms: "Mashamba yaliyoondolewa kwenye orodha",
    generateCertificate: "Tengeneza Cheti",
    viewDisputeHistory: "Tazama Historia ya Migogoro",
    disputeAssessment: "Tathmini ya Mizozo",

    reportDetails: "Maelezo ya Ripoti",
    productionPlace: "Mahali ya Uzalishaji",
    regionalRiskAssessment: "Tathmini ya Hatari ya Kikanda",
    EUDRDeforestationAssessment: "Tathmini ya Ukatili wa Mitini wa EUDR",
    EUDRcountry:
      "Nchi ambapo shamba liko, iliyounganishwa na bidhaa katika ripoti ya uchunguzi wa kina. Inasaidia katika kuhakikisha ufuatiliaji wa kijiografia kama inavyotakiwa na kanuni za EUDR.",
    riskAssessment: "Tathmini ya Hatari",
    legalInformation: "Maelezo ya Kisheria",
    finalReport: "Ripoti ya Mwisho",
    editGeolocation: "Hariri Mahali",
    producerCountry: "Nchi ya Mzalishaji",
    manuallyAddData: "Ongeza Data kwa Mikono",
    drawGeofence: "Chora Geofensi",
    uploadFile: "Pakia Faili",
    typeyourlocation: "Andika jina/anwani ya mahali yako",
    numberOfPoints: "Idadi ya Pointi za Pembetatu",
    viewGeolocation: "Angalia Mahali",
    geoLocation: "Mahali",
    Point: "Pointi",
    Circular: "Mviringo",
    Polygon: "Pembetatu",
    selectFileToUploadData: "Chagua faili ya kupakia data",
    submissionDate: "Tarehe ya Kuwasilisha",
    eudrReferenceNo: "Nambari ya Rejea ya EUDR",
    internalReferenceNo: "Nambari ya Rejea ya Ndani",
    exporter: "Mzalishaji",
    exporterInfo:
      "Jina la Mzalishaji. Chombo au chama kinachohusika na kusafirisha bidhaa.",
    importer: "Muingizaji",
    importerInfo:
      "Jina la Mzalishaji. Chombo au chama kinachohusika na kuingiza bidhaa.",
    shipmentReferenceNo: "Nambari ya Rejea ya Usafirishaji",
    shipmentReferenceNoInfo:
      "Kitambulisho cha kipekee kinachotumika kurejelea usafirishaji.",
    ownerShipType: "Aina ya Umiliki",
    ownerShipTypeInfo: "Aina ya umiliki unaohusishwa na usafirishaji.",
    buyer: "Mnunuzi",
    port_of_origin: "Bandari ya Asili",
    port_of_origin_info: "Mahali ambapo usafirishaji unapotokea.",
    port_of_destination: "Bandari ya Marudio",
    port_of_destination_info: "Bandari inayokusudiwa kwa usafirishaji.",
    no_of_stops: "Idadi ya Vituo",
    shipping_line: "Mstari wa Usafirishaji",
    shipping_line_info:
      "Kampuni au chombo kinachohusika na kusafirisha usafirishaji.",
    expected_arrival_date: "Tarehe ya Kuwasili Inayotarajiwa",
    expected_arrival_date_info:
      "Tarehe inayotarajiwa ya kuwasili kwa usafirishaji kwenye kipengele chake.",
    container_id: "Kitambulisho cha Kontena",
    container_id_info:
      "Kitambulisho cha kipekee cha kontena cha usafirishaji kinachotumika katika usafirishaji.",
    container_type: "Aina ya Kontena",
    container_type_info: "Aina au kategoria ya kontena cha usafirishaji.",
    container_size: "Ukubwa wa Kontena (ft)",
    container_size_info: "Vipimo vya kimwili vya kontena cha usafirishaji.",
    container_capacity: "Uwezo wa Kontena (Tani)",
    container_capacity_info:
      "Mzigo wa juu au uwezo wa kontena cha usafirishaji.",
    eudr_reference_number: "Nambari ya Rejea ya EUDR",

    select_default_measurement_units: "Chagua Vipimo vya Chaguo-msingi",
    radius: "Mzunguko",
    maximum_limit: "Kikomo cha Juu",
    product_mass: "Uzito wa Bidhaa",
    user_type: "Aina ya Mtumiaji",
    eudr_api_keys: "Vifunguo vya API vya EUDR Portal",
    api_key: "Funguo la API",
    api_secret: "Siri ya API",
    assessment_risk_mitigation_levels: "Ngazi za Uhakiki wa Upunguzaji Hatari",
    dynamic_expiry_time_period: "Kipindi cha Muda wa Kumalizika kwa Matumizi",
    eudr_deforestation_assessment: "Tathmini ya Ukataji wa Miti ya EUDR",
    auto_renewal: "Upya Otomatiki",
    auto_renewal_when_added_to_the_due_diligence_report:
      "Upya Otomatiki Wakati wa Kuongezwa kwenye Ripoti ya Uangalifu",
    declaration_statements: "Kauli za Taarifa",
    filter_declaration_statements: "Chuja Kauli za Taarifa",
    showing_all: "Inavyoonyesha Zote",
    declaration_title: "Kichwa cha Taarifa",
    applicable_countries: "Nchi Zinazotumika",
    enabled: "Imeweshwa",
    disabled: "Imezimwa",
    add_more: "Ongeza Zaidi",
    mark_as_default: "Weka kama Chaguo-msingi",
    locationVerificationTab: {
      confirmationTitle: "Uthibitisho",
      confirmationMessage:
        "Unakaribia kuhariri data ya geolocation ya shamba hili. Tafadhali kumbuka kuwa mabadiliko yoyote kwenye geolocation yatahitaji uhakiki tena wa hatua zote zinazohusiana, ikiwa ni pamoja na uthibitishaji wa eneo, uchambuzi wa ukataji miti, na tathmini ya hatari za kanda (ukaguzi wa maeneo yaliyohifadhiwa na ya kiasili). Mabadiliko ya jina la shamba au mkulima hayatahitaji uhakiki tena. Unataka kuendelea?",
    },
    locationModified: {
      headerTitle: "Maeneo Yaliyorekebishwa",
      headerDescription:
        "Tumegundua kuwa eneo lifuatalo limebadilishwa na linahitaji kuthibitishwa tena.",
    },
    processingDialog: {
      modalHeader: "Inachambua Hali ya Ukataji Miti",
      modalDescription_first: "Inachambua Hali ya Ukataji Miti wa EUDR",
      modalDescription_second:
        "Mashamba yako yanapitia Uchambuzi wa Kiotomatiki wa Ukataji Miti. Utapelekwa kwenye ukurasa wa orodha ya Ripoti za Uhakikisho wa Kina ili kuona hali hiyo.",
    },
    farmList: {
      title: "Orodha ya Shamba la EUDR",
      addFarmGeofenceManually: "Ongeza geofence ya shamba kwa mkono",
      importGeofenceInBulk: "INGIZA GEO-CENCEN KWA WINGI",
      searchPlaceHolder: "Tafuta kwa jina la mkulima",
      generateCertificate: "Tengeneza Cheti",
      requestAssementReport: "Omba Ripoti ya Tathmini",
      producer: "Mzalishaji",
      farmNameAndId: "Jina la Shamba na ID",
      addressOfProduction: "Anwani ya Uzalishaji",
      registrationDate: "Tarehe ya Usajili",
      eudrDeforestationStatus: "Hali ya Ukataji Miti wa EUDR",
      riskAssessmentStatus: "Hali ya Tathmini ya Hatari",
      assessmentTitle: "Kichwa cha Tathmini",
      assessmentDescription: "Maelezo ya Tathmini",
      submissionDate: "Tarehe ya Kuwasilisha",
      expiryDate: "Tarehe ya Kuisha",
      assessmentStatus: "Hali ya Tathmini",
      downloadAsKmx: "Pakua kama KMX",
      downloadAsKml: "Pakua kama KML",
      downloadAsShp: "Pakua kama SHP",
      downloadAsCsv: "Pakua kama CSV",
      downloadAsExcel: "Pakua kama EXCEL",
      downloadAsPdf: "Pakua kama PDF",
      downloadAsGeoJson: "Pakua kama GeoJSON",
      loadingFarms: "Inapakia mashamba",
    },
    dueDeligenceReport: "Marekebisho ya Ripoti ya Uchunguzi wa Umma",
    allowPublicDownload:
      "Ruhusu upakuaji wa wazi wa vizuizi vya shamba katika umbizo la GeoJson",
    showDeforestationSummary:
      "Onyesha muhtasari wa hatari ya ukataji miti wa EUDR kwa kitengo",
    cancel: "Ghairi",
    createShipment: "Unda Usafirishaji Mpya",
    actions: "Vitendo",
    operator: "Mfanyaji",
    buyerName: "Mnunuzi",
    donwload: "Pakua",
    print: "Chapisha",
    loading: "Inapakia...",

    deforestationAssessmentRiskToleranceLevel:
      "Kiwango cha Uvumilivu wa Hatari ya Tathmini ya Ukataji Miti",
    deforestationAssessmentRiskToleranceLevelInfo:
      "Tumia zana hii kusanidi ni asilimia ngapi ya ukataji miti, kwa kila kiwango, inayokubalika katika mchakato wako wa Tathmini ya Hatari. Mashamba yenye hatari ndogo au sawa na ilivyoainishwa yatachukuliwa kuwa yanafaa kubaki katika DDS, bila hitaji la kufanya Upunguzaji wa Hatari.",
    tons: "Tani",

    headingUpdatedSuccessfully: "Kichwa kimeboreshwa kwa mafanikio",
    headingCreatedSuccessfully: "Kichwa kimeundwa kwa mafanikio",
    failedToDeleteQuestion: "Imeshindikana kufuta swali",
    questionTypeNotDefined: "Aina ya swali haijabainishwa",
    questionOrderSuccessfullyUpdated:
      "Mpangilio wa maswali umesasishwa kwa mafanikio",
    headingOrderSuccessfullyUpdated:
      "Mpangilio wa vichwa umesasishwa kwa mafanikio",
    assessmentUpdatedSuccessfully: "Tathmini imesasishwa kwa mafanikio",
    pleaseWaitCurrentlyUpdatingChecklist:
      "Tafadhali subiri, inasasisha orodha ya ukaguzi",

    riskMitigation: "Utekelezaji wa Hatari",
    riskMitigationHistory: "Historia ya Utekelezaji wa Hatari",
    signParticipationSurvey:
      "Tafadhali saini kielektroniki kuthibitisha ushiriki wako katika uchunguzi huu?",
    signedBy: "Imetiwa Sahihi Kwa Dijitali Na:",
    assessmentRiskMitigation: "Utekelezaji wa Hatari ya Tathmini",
    assessmentDetails: "Maelezo ya tathmini",
    dontShowWarning: "Usionyeshe onyo hili tena.",
    dateSubmitted: "Tarehe ya kuwasilishwa",
    addAComment: "Ongeza maoni",
    changeAssignee: "Badilisha anayehusika",
    changeStatus: "Badilisha hali",
    assignedUser: "Mtumiaji aliyekabidhiwa",
    selectAssignee: "Chagua anayehusika",
    reply: "Jibu",
    discussion: "Majadiliano",
    attachment: "Kiambatisho",
    sizeKb: "Ukubwa (KB)",
    dateAdded: "Tarehe iliyoongezwa",

    loadingProductionPlaces: "Inapakia Maeneo ya Uzalishaji",

    shipmentStatus: "Hali ya Usafirishaji",
    viewStops: "Tazama Vituo",
    enRoute: "Njiani",
    delivered: "Imewasilishwa",
    failed: "Imeshindwa",
    download: "Pakua",
    removeEudrDeforestationStatus: "Ondoa Hali ya Ukataji Miti wa EUDR",
    riskAssessmentStatusIsRequired: "Hali ya tathmini ya hatari inahitajika",
    requestAdditionalInformationPage: {
      descriptionLabel: "Tafadhali toa maoni au maagizo mahususi kwenye kisanduku cha maandishi hapa chini. Ukishawasilisha, muuzaji ataarifiwa na kupewa ruhusa ya kuhariri ripoti ya uhakiki wa umakini. Utajulishwa pale muuzaji atakapoboresha ripoti.",
      shareAccessLabel: "Muuzaji kwa sasa hana ufikiaji wa ripoti hii. Je, ungependa kushiriki ufikiaji na muuzaji? Tafadhali chagua jinsi unavyotaka kushiriki ufikiaji:",
      shareCompleteReportLabel: "Shiriki ripoti kamili",
      shareSpecificStepLabel: "Shiriki hatua mahususi"
    },
    issueFound: "Shida Iliyopatikana",
    riskWarningModal: {
      issuesFound: "Matatizo {count} yamepatikana",
      farmId: "Kitambulisho cha shamba",
      issueId: "Kitambulisho cha tatizo",
      lastChecked: "Iliangaliwa mwisho",
      technicalDetails: "Maelezo ya kiufundi",
      showing: "Inaonyesha {from}–{to} kati ya matatizo {total}",
      downloadIssueLog: "Pakua kumbukumbu ya matatizo",
      noIssues: "Hakuna matatizo yaliyopatikana",
      loadFailed: "Imeshindwa kupakia maelezo ya tatizo",
      unnamedFarm: "Shamba lisilo na jina",
      searchPlaceholder: "Tafuta kwa jina au kitambulisho cha shamba…",
      allIssueTypes: "Aina zote za matatizo",
      whatHappened: "Kilichotokea",
      whatToDoNext: "Hatua inayofuata",
      viewStep: "Fungua hatua",
      checkHistory: "Historia ya ukaguzi",
      time: "Muda",
      event: "Tukio",
      result: "Matokeo",
      copyLog: "Nakili kumbukumbu",
      logCopied: "Kumbukumbu ya tatizo imenakiliwa",
      noHistory: "Bado hakuna ukaguzi uliorekodiwa kwa shamba hili.",
      technicalDetailsHint: "Vitambulisho na thamani ghafi kwa timu ya usaidizi",
      chips: {
        action_required: "Hatua inahitajika",
        needs_review: "Inahitaji ukaguzi",
        check_failed: "Ukaguzi umeshindwa",
        not_checked: "Haijakaguliwa",
        not_started: "Haijaanza",
        pending_approval: "Inasubiri idhini",
      },
      events: {
        farm_registered: "Shamba limesajiliwa",
        location_checked: "Ukaguzi wa eneo umerekodiwa",
        assessment_requested: "Tathmini imeombwa",
        result_recorded: "Matokeo yamerekodiwa",
        mitigation_added: "Hatua ya kupunguza imeongezwa",
        dispute_resolved: "Mzozo umetatuliwa",
        assessment_started: "Tathmini imeanza",
        assessment_updated: "Tathmini imesasishwa",
      },
      results: {
        started: "Imeanza",
        completed: "Imekamilika",
        needs_review: "Inahitaji ukaguzi",
        check_failed: "Ukaguzi umeshindwa",
        pending: "Inasubiri",
        approved: "Imeidhinishwa",
        rejected: "Imekataliwa",
      },
      issues: {
        ocean: {
          title: "Eneo liko baharini",
          finding: "Viwianishi vya shamba vinaonyesha sehemu iliyo baharini, kwa hiyo eneo la uzalishaji haliwezi kuthibitishwa.",
          action: "Rekebisha viwianishi au mpaka wa shamba katika Uthibitishaji wa Eneo.",
        },
        country_mismatch: {
          title: "Nchi hailingani",
          finding: "Shamba liko {detected}, lakini nchi ya uzalishaji katika ripoti ni {expected}.",
          action: "Rekebisha eneo la shamba, au sasisha nchi ya uzalishaji katika Maelezo ya Ripoti.",
        },
        point_over_4ha: {
          title: "Eneo la nukta zaidi ya ha 4",
          finding: "Shamba lina ha {area} lakini lina eneo la nukta tu. EUDR inahitaji poligoni kwa mashamba yanayozidi ha 4.",
          action: "Ongeza mpaka wa poligoni kwa shamba hili.",
        },
        country_not_defined: {
          title: "Nchi ya uzalishaji haijawekwa",
          finding: "Ripoti haina nchi ya uzalishaji, kwa hiyo eneo la shamba haliwezi kulinganishwa.",
          action: "Weka nchi ya uzalishaji katika Maelezo ya Ripoti.",
        },
        polygon_overlap: {
          title: "Mpaka unaingiliana na shamba jingine",
          finding: "Mpaka wa shamba hili unaingiliana na: {overlaps}.",
          action: "Kagua mipaka yote miwili na urekebishe usio sahihi, au ondoa shamba lililorudiwa.",
        },
        deforestation_risk: {
          title: "Hatari ya ukataji miti imegunduliwa",
          finding: "Tathmini ya ukataji miti ilirudisha \"{status}\" kwa shamba hili.",
          action: "Kagua matokeo na uongeze hatua za kupunguza au ushahidi, au ondoa shamba kwenye ripoti.",
        },
        assessment_incomplete: {
          title: "Tathmini haijakamilika",
          finding: "Tathmini ya ukataji miti haikuweza kutoa matokeo kwa shamba hili (NA).",
          action: "Endesha tena tathmini ya ukataji miti au kagua mpaka wa shamba.",
        },
        not_assessed: {
          title: "Bado halijatathminiwa",
          finding: "Hakuna tathmini ya ukataji miti iliyofanywa kwa shamba hili.",
          action: "Endesha tathmini ya ukataji miti ya EUDR kwa shamba hili.",
        },
        assessment_missing: {
          title: "Tathmini haijaanza",
          finding: "Shamba hili bado halina jibu kwa tathmini hii.",
          action: "Kamilisha tathmini kwa shamba hili.",
        },
        assessment_not_approved: {
          title: "Tathmini haijaidhinishwa",
          finding: "Tathmini ya shamba hili iko katika hali ya \"{status}\", haijaidhinishwa.",
          action: "Kagua na uidhinishe tathmini ya shamba hili.",
        },
      },
    },
    complianceRiskWarningsTT: "Arifa za Onyo la Hatari zinakuarifu kuhusu masuala ya ufanisi yanayoweza kutokea katika kila hatua ya mchakato wa uhakiki wa umakini. Arifa hizi husaidia kuhakikisha kwamba hatari zote zinatambuliwa kabla ya kuendelea na hatua inayofuata. Unaweza kuwezesha au kuzima arifa hizi wakati wowote katika Mipangilio ya Ripoti au wakati wa kuunda ripoti.",
    statusLegend: "Maelezo ya Hali",
    statusLegendInfo: "Maelezo ya hali yanatoa muhtasari wa haraka wa hali ya sasa ya ripoti ya uchunguzi wa kina. Inatumika kuonyesha hali ya sasa ya ripoti na hatua zinazoweza kuchukuliwa ili kuisasisha.",
    sentToExporter: "Imetumwa kwa Muuzi",
    approved: "Imekubaliwa",
    updateRequired: "Inahitaji Kusasishwa",
    rejected: "Imekataliwa",
    noExporterFound: "Hakuna mzalishaji aliyeonekana",
    exporterFoundSuccessfully: "Mzalishaji amepatikana kwa mafanikio",
    enterExporterEmail: "Ingiza Barua Pepe ya Mzalishaji",
    shareReport: "Shiriki Ripoti",
    exporterInformation: "Taarifa za Mzalishaji",
    pleaseEnterExporterEmail: "Tafadhali ingiza barua pepe ya mzalishaji",
    
  },
  dueDiligence: {
    showFarmWithIssues: "Onyesha mashamba yenye matatizo",
    question: "Swali",
    answer: "Jibu",
    comments: "Kommenti",
    commentsRegardingStatement: "maoni kuhusu taarifa",
    countryOfProduction: "Nchi ya Uzalishaji",
    countryOfProductionTT: "Nchi ya Uzalishaji",
    containerId:"Kitambulisho cha kontena",
    createWithoutRiskAssessment: {
      title: "Unda DDS Bila Tathmini ya Hatari",
      message: "Je, unataka kuunda DDS bila kuongeza Tathmini ya Hatari? Ikiwa ndivyo, sheria za ukaguzi wa malalamiko zitapuuza hatua hii.",
      confirmBtnText: "Ndiyo",
      cancelBtnText: "Hapana",
      doNotShowAgain: "Usionyeshe ujumbe huu tena"
    },
    noAssessmentWarning: "Ripoti ya DDS inakosa tathmini za hatari.",
    disputeReason: "Tafadhali chagua sababu ya mzozo.",
    agricultureAgreement: "Tafadhali kubali masharti kabla ya kuendelea.",
    attachDisputeFile: "Tafadhali ambatanisha faili kabla ya kufungua mzozo.",

    // Activity Log translations
    activityLog: "Kumbukumbu ya shughuli",
    activityLogTT: "Kumbukumbu ya vitendo vilivyofanywa kwenye ripoti hii.",
    user: "Mtumiaji",
    userRole: "Wadhifa wa mtumiaji",
    ipAddress: "Anwani ya IP",
    segment: "Sehemu",
    activityDescription: "Maelezo ya shughuli",
    listOfFarmsInfo:
      "Onyesho la kina la mashamba, ikiwa ni pamoja na taarifa kama eneo la uzalishaji, jina la mzalishaji, nchi ya kazi, eneo la ardhi katika hekta, aina ya shughuli za kilimo, tathmini zinazohusiana na ukataji miti, na tathmini ya hatari zinazowezekana zinazohusiana na shughuli za shamba.",
    producerTT:
      "Uchaguzi wa wazalishaji au watengenezaji wanaohusika katika mlolongo wa usambazaji.",
    supplierInformationTT: "Maelezo kuhusu taasisi inayotoa bidhaa au huduma.",
    operatorTooltip:
      "Chagua Mwendeshaji kutoka kwenye orodha iliyosajiliwa awali kwenye mfumo",
    supplierTooltip:
      "Chagua muuzaji kutoka kwenye orodha iliyoandikishwa awali kwenye mfumo.",
    requiredAssessmentTooltip: "Chagua taarifa zinazohitajika za tathmini.",
    internalRefNoTooltip:
      "Kitambulisho cha kipekee kinachotolewa ndani ya shirika au mfumo ili kurejelea data, miamala au rekodi maalum kwa madhumuni ya ufuatiliaji wa ndani na usimamizi.",
    eudrRefNoTooltip:
      "Inarejelea kitambulisho cha kipekee kilichounganishwa na Kanuni za Kifurushi za Ulaya za Ukataji Miti (EUDR), zinazotumika kufuatilia na kurejelea taarifa zinazohusiana na uzingatiaji wa sheria za ukataji miti.",
    companyIdTooltip:
      "Kitambulisho tofauti kinachotolewa kwa kampuni au shirika kwa madhumuni ya utambulisho na ufuatiliaji, mara nyingi hutumiwa ndani ya mifumo, hifadhidata au mfumo wa sheria.",
    placeOfActivityTooltip:
      "Taja nchi ya mwendeshaji ambapo shughuli zinafanyika na nchi ambapo bidhaa itaingia kwenye soko la EU. Maelezo haya ni muhimu kwa kufuata kwa usahihi mahitaji ya EUDR.",
    productDetailToolTip:
      "Inatoa maelezo ya kina kuhusu bidhaa, ikijumuisha jina lake, uzito halisi, kiasi, jina la kisayansi na jina la kawaida.",
    productToolTip:
      "Jina la Bidhaa. Inarejelea kitu kinachoweza kushikika au bidhaa zinazozalishwa, kutengenezwa au kuuzwa na kampuni.",
    productDescToolTip:
      "Inatoa maelezo au muhtasari wa maandishi wa sifa, kazi au tabia za bidhaa, kwa lengo la kuwajulisha watumiaji au wateja kuhusu asili au utendaji wake.",
    subProductToolTip:
      "Jina la Bidhaa Ndogo. Inaonyesha kitengo maalum au kitengo kidogo cha bidhaa kubwa, kawaida hutumika kwa uainishaji wa ziada au utofautishaji ndani ya uongozi wa bidhaa.",
    netMassTooltTip:
      "Inaonyesha uzito wa bidhaa au kitu, mara nyingi bila kujumuisha uzito wa kifungashio au vifaa vingine.",
    volumeToolTip:
      "Inarejelea kiasi cha nafasi kinachochukuliwa na bidhaa au dutu, mara nyingi kipimo kwa vipimo vya ujazo kama mita za ujazo au futi za ujazo, zinazotumika kupima uwezo au kiasi ndani ya nafasi ya pande tatu.",
    scientificNameToolTip:
      "Jina la kisayansi la kiumbe kinachojumuisha jenasi na spishi, kwa mfano, Coffea Arabica, Theobroma cacao L.",
    commonNameToolTip:
      "Jina lililojikita kwenye lugha ya kila siku, kwa mfano, Kakao, Kahawa.",
    manualProductionPlaceTooltip:
      "Mchakato wa kuingiza kwa mikono maeneo ya uzalishaji kwenye mfumo.",
    producerNameTT:
      "Jina la mtu binafsi/kampuni/shirika linalozalisha na kutoa bidhaa au huduma.",
    producerCountryTT: "Nchi ya asili ya mzalishaji.",
    dueDiligence: "Uangalizi wa Kina",
    assementBuilder: "Mjenzi wa Tathmini",
    assessment: "Tathmini",
    assessmentsList: "Orodha ya Tathmini",
    createAssessment: "Unda Tathmini",
    assessmentName: "Jina la Tathmini",
    assessmentNameInfo: "Kipengele cha kupata tathmini maalum au taarifa.",
    searchAssessment: "Tafuta Tathmini",
    selectProcess: "Chagua Mchakato wa Tathmini",
    assessSettings: "Mipangilio ya Tathmini",
    assessmentTitle: "Kichwa cha Tathmini",
    assessmentTitleInfo: "Jina linalotambulisha tathmini.",
    assessDescription: "Maelezo ya Tathmini",
    assessDescriptionInfo:
      "Maelezo mafupi ya madhumuni au maudhui ya tathmini.",
    describeAsessment: "Eleza Tathmini",
    selectCountry: "Chagua Nchi",
    expiryTime: "Muda wa Kumalizika",
    expiryTimeInfo: "Muda hadi tathmini iishe au kuwa batili.",
    noQuestionEachStep: "Idadi ya Maswali kila Hatua",
    byHeadings: "Kwa Vichwa",
    assessmentStatus: "Hali ya Tathmini",
    multiStepAssess: "Tathmini ya Hatua Nyingi",
    allowAssessment: "Ruhusu tathmini ijibiwe mara zaidi ya moja",
    onlyIfExpired: "Ikiwa tu Imekwisha",
    atAnyTime: "Wakati Wowote",
    editAssessmentDetails: "Hariri Maelezo ya Tathmini",
    assessmentDetail: "Maelezo ya Tathmini",
    addQuestion: "Ongeza Swali la Tathmini",
    attachFiles: "Ambatisha Faili",
    digitalSignature: "Sahihi ya Kidijitali",
    showChecklist: "Onyesha Orodha ya Ukaguzi",
    hideChecklist: "Ficha Orodha ya Ukaguzi",
    fileType: "Aina ya Faili",
    allowMultipleFile: "Ruhusu Viambatisho Vingi",
    allowComment: "Ruhusu Maoni",
    uploadSignatureFile: "Pakia Faili ya Saini",
    drawSignature: "Chora Saini",
    addSubHeading: "Ongeza Kichwa Kidogo",
    heading: "Kichwa",
    headingInfo:
      "Kichwa ambacho swali la tathmini litatolewa. Menyu kunjuzi ya kuchagua kichwa.",
    subHeading: "Kichwa Kidogo",

    dueDiligenceReports: "Ripoti za Uangalizi wa Kina",
    manageFarms: "Simamia Mashamba",
    disputeResolution: "Kutatua Mizozo",
    suppliers: "Wauzaji",
    shipments: "Usafirishaji",
    dueDiligenceGuide: "Mwongozo wa Uangalizi wa Kina",

    selectRequiredAssessment: "Chagua Tathmini Inayohitajika",
    filterAssessments: "Chuja Tathmini",
    dueDiligenceReportCreation: "Uundaji wa Ripoti ya Uangalizi wa Kina",

    dueDiligenceNew: "Uangalizi wa Kina",
    createNewReport: "Unda Ripoti Mpya",
    operator: "Mfanyaji",
    supplier: "Muuzaji",
    addMoreAssessments: "Ongeza Tathmini Zaidi",
    internalReferenceNumber: "Nambari ya Kumbukumbu ya Ndani",
    referenceNumber: "Nambari ya Kumbukumbu",
    domestic: "Ndani",
    import: "Kuagiza",
    export: "Kuuza Nje",
    selectProduct: "Chagua Bidhaa",
    selectSubProduct: "Chagua Bidhaa Ndogo",
    addnewSupplier: "Ongeza Muuzaji Mpya",
    farmDeforestationReport: "Ripoti ya Ukatili wa Mitini wa Shamba",

    addProductionPlaceData: "Ongeza Data ya Mahali pa Uzalishaji",
    addProductionPlaceDataTooltip: "Chagua jinsi unavyotaka kuongeza data",
    addProductionPlaceDataDesc:
      "Unda ripoti zako kwa kuingiza data za uzalishaji kutoka vyanzo mbalimbali. Chagua chanzo kimoja au zaidi kuunda orodha kamili ya maeneo ya uzalishaji kwa ripoti zako.",
    dimitraApps: "Programu za Dimitra",
    addNew: "Ongeza Mpya",
    existingData: "Data Zilizopo",
    manualDataEntry: "Ingiza Data kwa Mkono",
    importFile: "Leta Faili",
    connectedCoffee: "Kahawa Iliyounganishwa",
    connectedCacao: "Kakao Iliyounganishwa",
    connectedFarmer: "Mkulima Mwakilishi",
    manaulProductionPlace: "Ingiza Data za Mahali ya Uzalishaji kwa Mkono",
        farmerRegistrationId: "ID ya Usajili wa Mkulima",
farmRegistrationId: "ID ya Usajili wa Shamba",
    manaulProductionPlaceTooltip:
      "Ingiza Data za Mahali ya Uzalishaji kwa Mkono",
    addProductionPlace: "Ongeza Mahali pa Uzalishaji",
    producerName: "Jina la Mzalishaji",
    producerCountry: "Nchi ya Mzalishaji",
    totalArea: "Eneo Jumla",
    number: "Namba",
    productionPlaceDesc: "Maelezo ya Mahali pa Uzalishaji",
    area: "Eneo  (ha)",
    type: "Aina",
    actions: "Vitendo",
    selectType: "Chagua Aina",
    importProductionPlace: "Leta Mahali pa Uzalishaji",
    downloadXLSFormat: "Pakua Format ya XLS",
    downloadGeoJsonFormat: "Pakua Format ya GeoJSON",
    downloadXMLFormat: "Pakua Format ya XML",
    downloadFileFormatTemplates: "Pakua Templeti ya Format ya Faili",
    importantNote: "Maelezo Muhimu",
    pleaseProvideFollowing: "Tafadhali toa format zifuatazo (GeoJSON na XML)",
    existingProductionPlaces: "Maeneo ya Uzalishaji Yaliyopo",
    productionPlaceAndFarmID: "Mahali pa Uzalishaji & ID ya Shamba",
    selectFileToUploadData: "Chagua faili ya kupakia data",
    filterByDate: "Panga Kulingana na Tarehe",
    dateOfRegister: "Tarehe ya Usajili",
    dateOfLastReport: "Tarehe ya Ripoti ya Mwisho",
    clearAll: "Ondoa Yote",
    addLocation: "Ongeza Mahali",

    pleaseCompleteBeforeProceedingToNext:
      "Tafadhali kamilisha sehemu ya maelezo ya ripoti kabla ya kuendelea na hatua inayofuata.",
    progressSavedSuccessMsg: "Maendeleo yamehifadhiwa kwa mafanikio!",
    failedSavedProgress:
      "Imeshindwa kuhifadhi maendeleo. Tafadhali jaribu tena.",
    failedToCreateReportDetails:
      "Imeshindwa kuunda ReportDetails. Tafadhali jaribu tena.",
    unExpectedErrorMsg:
      "Hitilafu isiyotarajiwa imetokea. Tafadhali jaribu tena.",
    selectAssessment: "Chagua Tathmini",
    confirmationPopup: "Kidirisha cha Uthibitisho",
    confirmationPopupMsg:
      "Je, una uhakika unataka kuacha ripoti hii? Kuthibitisha kitendo hiki kutasababisha kufutwa kabisa.",
    warningPopup: "Kidirisha cha Onyo",
    warningPopupMsg:
      "Je, una uhakika unataka kukataa ripoti hii? Tafadhali kumbuka: Takwimu za ripoti hii zitaokolewa baada ya kukataliwa iwapo utataka kuikagua baadaye.",
    automatedDeforestationProgressText:
      "Ukaguzi wa kiotomatiki wa data za geovalla na utambuzi wa kesi muhimu za ukataji miti",
    someRiskWereIdentifiedText:
      "Hatari fulani zilitambuliwa katika shamba lifuatalo, unapaswa kukagua shamba na hatari zilizotambuliwa na kuzizuia kabla ya kuendelea na hatua inayofuata.",
    riskAssessmentAndMitigation: "Tathmini na Kupunguza Hatari",
    riskAssessmentStatus: "Hali ya Tathmini ya Hatari",
    riskAssessment: "Tathmini ya Hatari",
    uploadRiskAssessment: "Pakia Tathmini ya Hatari",
    uploadRiskAssessmentTT: "Hatua ya kupakia hati ya tathmini ya hatari.",
    manualFillOutAssessment: "Jaza tathmini kwa mkono",
    manualFillOutAssessmentTT: "Hatua ya kumaliza fomu ya tathmini kwa mkono.",
    criteria: "Vigezo (b, f na g)",
    downloadAssessmentForm: "Pakua Fomu ya Tathmini",
    addSignature: "Ongeza Saini",
    uploadImage: "Pakia Picha",
    createNewDueDiligenceProgress: "Unda Mchakato Mpya wa Uangalizi",
    usageLimits: "Mipaka ya Matumizi",
    totalReports: "Jumla ya Ripoti",
    eudrDeforestationAssessments: "Tathmini za Ukataji Miti za EUDR",
    totalAssessments: "Jumla ya Tathmini",
    listOfFarms: "Orodha ya Mashamba",
    perMonth: "Kwa Mwezi",
    share: "Shiriki",
    viewReport: "Tazama Ripoti",
    viewReportSummary: "Tazama Muhtasari wa Ripoti",
    copy: "Nakili",
    copyAndCreateNew: "Nakili na Unda Mpya",
    listOfSupplier: "Orodha ya Wauzaji",
    addNewSupplier: "Ongeza wauzaji wapya",
    editSupplier: "Hariri Muuza",
    supplierName: "Jina la Muuza",
    listOfOperators: "Orodha ya Waendeshaji",
    addNewOperator: "Ongeza Waendeshaji Wapya",
    operatorName: "Jina la Mwendeshaji",
    operators: "Waendeshaji",
    editOperator: "Hariri Mwenda",
    eoriNumber: "Nambari ya EORI",
    isoCode: "Nambari ya ISO",
    enterEmailAddress: "Weka anwani ya barua pepe",
    enterFirstName: "Weka jina la kwanza",
    enterLastName: "Weka jina la mwisho",
    enterEORINumber: "Weka nambari ya EORI",
    myFarms: "Mashamba Yangu",
    listOfProducers: "Orodha ya Watengenezaji",
    producers: "Watengenezaji",
    addNewProducer: "Ongeza Mtengenezaji Mpya",
    lastAssessment: "Tathmini ya Mwisho",
    noOfFarms: "Idadi ya Mashamba",
    shipmentID: "Kitambulisho cha Usafirishaji",
    noOfReports: "Idadi ya Ripoti",
    operatorSelect:
      "Mwendeshaji: Chagua chaguo hili ikiwa wewe, kama mwendeshaji, utawajibika kuongeza data za sehemu ya uzalishaji. Utakuwa na chaguo la kutoa orodha ya watayarishaji, mashamba yao, na maeneo ya kijiografia ndani ya programu.",
    supplierSelect:
      "Muuzaji: Chagua chaguo hili ikiwa muuzaji atawajibika kuongeza data za sehemu ya uzalishaji. Watakuwa na uwezo wa kutoa orodha ya watayarishaji, mashamba yao, na maeneo ya kijiografia moja kwa moja ndani ya programu.",
    selectWhoWillAddPlaceData:
      "Chagua ni nani atakayetoa Data za Sehemu ya Uzalishaji",
    selectUsers: "Chagua Watumiaji",
    country: "Nchi",
    mutiStepHeadingLable: "Unda Hatua Mpya kwa kila Kichwa Kidogo",
    logistics: "Usafirishaji",
    editSubHeading: "Hariri Kichwa Kidogo",
    headingTitle: "Kichwa Kikuu",
    partOfOrigin: "Sehemu ya Asili",
    destination: "Sehemu ya Kuelekea",
    addStop: "Ongeza Kituo",
    stop: "Kituo",
    enterStop: "Ingiza Kituo",
    shipmentList: "Orodha ya Usafirishaji",
    createShipment: "Unda Usafirishaji Mpya",
    disputeAssessment: "Tathmini ya Mgogoro",
    multiStepQuestion1: "Unda Hatua Mpya baada ya",
    questions: "maswali",
    questionsInfo:
      "Idadi ya maswali katika kila hatua ya tathmini ya hatua nyingi.",
    confirmation: "Uthibitisho",
    saveAndConfirmationMessage: "Una uhakika unataka kuhifadhi mabadiliko?",

    confirmDownload:
      "Je, ungependa kupakua viambatisho vyote katika fomati ya PDF?",

    selectProductionPlacesUsingLots:
      "Chagua maeneo ya uzalishaji kwa kutumia lote",
    SelectProductionPlacesUsingFarms:
      "Chagua maeneo ya uzalishaji kwa kutumia mashamba",

    areaForPointGeofence: "Eneo kwa Geofence ya Mviringo",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Kulingana na EUDR, mashamba yenye chini ya ekari 4 hayahitaji poligoni.",
    circularAreaEquivalent:
      "Katika hali hizi, tutatumia eneo la mduara linalolingana na ukubwa wa shamba, na nukta ya GPS iliyotolewa kama kitovu ili kuthibitisha ukataji miti. Ikiwa ukubwa wa shamba haujatolewa, tutatumia ekari 4 kama chaguo-msingi.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow:
      "Ikiwa mashamba ni madogo zaidi, tafadhali ingiza ukubwa wa kawaida kwenye uwanja hapa chini.",
    defaultCircularGeofence:
      "Mashamba bila geofence au taarifa kuhusu ukubwa wao watapewa geofence ya mduara ya ekari 4 kama chaguo-msingi. Ikiwa ukubwa wa wastani wa shamba ni chini ya ekari 4, badilisha ukubwa wa chaguo-msingi kwa kubonyeza kitufe cha 'Hariri' hapa chini.",
    defaultAreaValueSpecified:
      "Mashamba yasiyo na geofence au eneo yatapewa thamani ya eneo chaguomsingi iliyoainishwa hapa chini na yatapewa geofence ya mviringo yenye kipenyo cha mduara.",
    uploadFileBeingProcessed:
      "Faili zako zilizopakuliwa zinachakatwa. Utapelekwa kwenye ukurasa wa orodha ya ripoti za tahadhari ili kuona hali.",
    processingLocations: "Kuchakata Maeneo",

    lotId: "ID ya Lote",
    lotIds: "ID za Lote",
    product: "Bidhaa",
    qualityGade: "Daraja la Ubora",
    processingDate: "Tarehe ya Uchakataji",

    importProductionPlaceTT:
      "Inaruhusu watumiaji kuagiza data ya mahali pa uzalishaji kwa kutumia chaguo za kupakia au kupakua faili.",
    internalReferenceNumberTT:
      "Nambari ya kumbukumbu ya ndani au msimbo unaotumika kwa mpangilio wa ripoti za tahadhari.",

    onlyShowFarmsWithIssues: "Onyesha mashamba yenye matatizo pekee",

    analyzingStatus: "Inachambua Hali ya Uharibifu wa Misitu",
    analyzingDesc:
      "Mashamba yako yanapitia Uchambuzi wa Uharibifu wa Misitu kwa Kidijitali. Utarudishwa kwenye ukurasa wa Orodha ya Ripoti za Uangalizi wa Upande wa Sheria ili kuona hali.",
    readyToProceed: "Tayari Kuendelea",
    mitigationRequired: "Lazima Kufanywa Mipango ya Kupunguza Madhara",
    viewSummary: "Tazama Muhtasari",
    viewAssessment: "Tazama Tathmini",
    disputes: "Migogoro",
    manualRiskMitigation: "Kupunguza Hatari kwa Mkono",
    veryHighProbability: "Uwezekano wa Juu Sana",
    highProbability: "Uwezekano wa Juu",
    mediumProbability: "Uwezekano wa Kati",
    lowProbability: "Uwezekano wa Chini",
    veryLowProbability: "Uwezekano wa Chini Sana",
    zeroProbability: "Hakuna/Hauna Uwezekano",
    manualMitigated: "Imerahisishwa kwa Mikono",
    disputeDesc:
      "Bonyeza moja ya ombi la migogoro hapa chini ili kuona maelezo zaidi.",
    geofenceColorCode: "Kode ya Rangi ya Geofence:",
    noDisputeHaveSubmitted: "Hakuna migogoro iliyowasilishwa bado",
    disputeDetails: "Maelezo ya Migogoro",
    chooseDisputeReason: "Chagua Sababu ya Migogoro",
    pleaseAttachDoc:
      "Tafadhali ambatisha nyaraka/picha kuthibitisha majibu yako.",
    additionalNotes: "Maelezo Zaidi",
    aggrementStatement:
      "Ninakubali kuwa ardhi iliyohusishwa haitatumika kwa kilimo katika miaka ijayo.",
    addGeofenceRadius: "Ongeza Kipenyo cha Geofence",
    totalGeofenceRadius: "Kipenyo cha Jumla cha Geofence ni",
    resolutionHistory: "Historia ya Utatuzi",
    proceed: "Endelea",
    wildFire: "Moto wa Asili",
    controlledFire: "Moto wa Kudhibitiwa",
    clearingForAgriculture: "Uondoaji wa Ardhi kwa Kilimo na/au Mifugo",
    pestAndDiseases: "Madhara ya Wadudu na Magonjwa",
    naturalChangesInCanopy:
      "Mabadiliko ya Kawaida katika Kivuli (kama kuanguka kwa majani msimu)",
    strongWinds: "Vimbunga Vikali (kama kimbunga au kimbunga)",
    otherNaturalDisasters: "Majanga mengine ya asili",
    flooding: "Maafa ya Mafuriko",
    logging: "Uchimbaji wa Misitu",
    infrastructure: "Miundombinu",
    urbanization: "Urbanization",
    landGrabbingOrPopulationPressure:
      "Utekaji wa Ardhi, Kilimo cha Kujikimu au Shinikizo la Watu",
    mining: "Uchimbaji wa Madini",
    plantationForestBeforeDeadline:
      "Ni msitu wa mashamba au ardhi yenye miti, lakini misitu ya asili au misitu inayorejeshwa iligeuzwa kuwa msitu wa mashamba au ardhi nyingine yenye miti kabla ya tarehe ya mwisho (31 Desemba 2020)",
    convertedToPlantationForest:
      "Misitu ya asili au misitu inayorejeshwa iligeuzwa kuwa msitu wa mashamba au ardhi nyingine yenye miti",
    cultivatedAreaBeforeDeadline:
      "Ni eneo la kilimo, na halikuwahi kuondolewa msitu baada ya tarehe ya mwisho (31 Desemba 2020)",
    forestStillPreserved:
      "Kuna msitu katika eneo hilo, lakini haujaondolewa na bado umehifadhiwa",
    downloadAsPDF: "Pakua kama PDF",
    downloadAsJSON: "Pakua kama JSON",
    downloadOptions: "Chaguo za upakuaji",
    productionPlacesHighDeforestationProbability:
      "Sehemu za uzalishaji zina uwezekano wa juu wa uharibifu wa misitu",
    geofenceHighDeforestationProbability:
      "Geofence ina uwezekano wa juu wa uharibifu wa misitu",
    EUDRReferenceNumber: "Nambari ya Marejeleo ya EUDR",
    commonName: "Jina la Kawaida",
    totalNoOfRiskAssessment: "Jumla ya Tathmini za Hatari",
    totalNoOfHighDeforestation:
      "Jumla ya Mashamba yenye Uwezekano wa Juu wa Uharibifu wa Misitu",
    totalNoOFDeforestationAssessments:
      "Jumla ya Tathmini za Uharibifu wa Misitu",
    totalNoOfFarms: "Jumla ya Mashamba",
    totalNoOfGeofencePoints: "Jumla ya Alama za Geofence",
    totalNoOfGeofencePolygons: "Jumla ya Poligoni za Geofence",
    reportSummary: "Muhtasari wa Ripoti",
    supplierData: "Data ya Mtoaji",
    operatorData: "Data ya Mtendaji",
    dueDiligenceReportStatus: "Hali ya Ripoti ya Uangalizi wa Upande wa Sheria",
    declarationStatement: "Taarifa ya Taarifa kutoka kwa Opereta",
    undoDelete: "Ghairi Kufuta",
    analyzingDeforestation: "Inachanganua Uharibifu wa Misitu",
    processingFarm: "Inachakata Shamba",
    supplierNotRegisterContent:
      "Muuzaji hajajisajili. Je, unataka kumtumia muuzaji arifa kwa barua pepe ili ajiunge na jukwaa?",
    supplierTT:
      "Uteuzi wa wasambazaji au watengenezaji wanaohusika katika mlolongo wa ugavi.",
    pleaseSelectAtLeastOneItem: "Tafadhali chagua angalau kipengele kimoja.",

    uploadingToBlockchain:
      "Inapakia ripoti kwenye blockchain, tafadhali subiri...",
    beingUploadToBlockChain:
      "Ripoti yako ya Ukaguzi wa Uaminifu inapakuliwa kwenye blockchain. Utapelekwa kwenye ukurasa wa orodha ya Ripoti za Uaminifu ili kuona hali.",
    uploading: "Inapakia",
    attachFile: "Ambatanisha Faili",
    close: "Funga",
    status: "Hali",
    lotID: "Kitambulisho cha Kiholela",
    noOfFarm: "Nambari ya Mashamba",
    origin: "Asili",
    selectUsingLots: "Chagua Mahali pa Uzalishaji kwa Kutumia Loti",
    productionPlaceUsingFarms:
      "Chagua Mahali pa Uzalishaji kwa Kutumia Mashamba",
    searchFarmName: "Tafuta jina la shamba",
    viewLocation: "Tazama Mahali",
    netMassKG: "Masi Safi (kg)",
    volumeM3: "Kiasi (m³)",
    areaInHA: "Eneo (ha)",
    eudrUploadedToBlockChain:
      "Mafanikio! Ripoti ya Uaminifu wa EUDR imepakuliwa kwa mafanikio kwenye Blockchain.",
    viewDeforestationAssessment: "Tazama Tathmini ya Kuangamiza",
    viewDeforestationCertificate: "Tazama Cheti cha Kuangamiza",
    selectCountries: "Chagua Nchi",
    writingToBlockchain: "Kuandika kwenye Blockchain",

    cattle: "Ng'ombe",
    cocoa: "Kakao",
    coffee: "Kahawa",
    wood: "Mbao",
    soya: "Soya",
    rubber: "Mpira",
    oilPlam: "Mafuta ya palmoil",

    subProduct1: "0102 21 , 0102 29 Ng'ombe hai",
    subProduct2: "0201 Nyama ya ng'ombe, mbichi au baridi",
    subProduct3: "0202 Nyama ya ng'ombe, iliyogandishwa",
    subProduct4: "0206 10 Nyama ya ng'ombe inayoliwa, mbichi au iliyopoa",
    subProduct5: "0206 22 Maini ya ng'ombe wa kuliwa, yaliyogandishwa",
    subProduct6:
      "0206 29 Nyama ya ng'ombe wa kuliwa (isipokuwa ndimi na maini), waliogandishwa",
    subProduct7:
      "1602 50 Nyama nyingine iliyotayarishwa au kuhifadhiwa, nyama ya nyama, damu, ya ng'ombe",
    subProduct8:
      "4101 Ngozi mbichi na ngozi za ng'ombe (mbichi, au zilizotiwa chumvi, zilizokaushwa, zilizotiwa chokaa, kung'olewa au kuhifadhiwa kwa njia nyinginezo, lakini hazijachujwa, zimepambwa kwa ngozi au zimetayarishwa zaidi), iwe imekatwa nywele au haijapasuliwa.",
    subProduct9:
      "4104 Ngozi zilizochujwa au ukoko na ngozi za ng'ombe, zisizo na nywele, iwe zimepasuliwa au hazipasuliwa, lakini hazijatayarishwa zaidi.",
    subProduct10:
      "4107 Ngozi ya ng'ombe, iliyotayarishwa zaidi baada ya kuchujwa au kukaushwa, ikijumuisha ngozi iliyovaliwa, isiyo na nywele, iwe imepasuliwa au isipasuliwa, zaidi ya ngozi ya kichwa 4114",
    subProduct11:
      "1801 Maharage ya kakao, nzima au kuvunjwa, mbichi au kuchomwa",
    subProduct12:
      "1802 Maganda ya kakao, maganda, ngozi na taka nyingine za kakao",
    subProduct13: "1803 Paka ya kakao, iwe imepunguzwa mafuta au la",
    subProduct14: "1804 Siagi ya kakao, mafuta na mafuta",
    subProduct15:
      "1805 Poda ya kakao, isiyo na sukari iliyoongezwa au vitu vingine vya utamu",
    subProduct16: "1806 Chokoleti na maandalizi mengine ya chakula yenye kakao",
    subProduct17:
      "0901 Kahawa, iwe imechomwa au haijatiwa kafeini; maganda ya kahawa na ngozi; vibadala vya kahawa vyenye kahawa kwa uwiano wowote",
    subProduct18: "1207 10 Mawese na kokwa",
    subProduct19:
      "1511 Mafuta ya mawese na sehemu zake, iwe au haijasafishwa, lakini haijabadilishwa kemikali",
    subProduct20:
      "1513 21 Punje ghafi ya mawese na mafuta ya babassu na sehemu zake, iwe imesafishwa au la, lakini haijabadilishwa kemikali.",
    subProduct21:
      "1513 29 Palm kernel na mafuta ya babassu na sehemu zake, iwe imesafishwa au haijasafishwa, lakini haijabadilishwa kemikali (bila kujumuisha mafuta yasiyosafishwa)",
    subProduct22:
      "2306 60 Keki ya mafuta na mabaki mengine dhabiti ya mitende au kokwa, iwe ya kusagwa au si kwa namna ya pellets, kutokana na uchimbaji wa mawese au mafuta ya kokwa au mafuta.",
    subProduct23:
      "2905 45 Glycerol, na usafi wa 95% au zaidi (inayohesabiwa kwa uzito wa bidhaa kavu)",
    subProduct24:
      "2915 70 Asidi ya Palmitiki, asidi ya steariki, chumvi zao na esta",
    subProduct25:
      "2915 90 Asidi za acyclic monocarboxylic zilizojaa, anhidridi, halidi, peroksidi na peroksidi; derivatives zao za halojeni, sulfonated, nitrate au nitrosated (ukiondoa asidi formic, asidi asetiki, mono-, di- au trikloroasetiki asidi, asidi ya propionic, asidi butanoic, asidi pentanoic, palmitic, asidi stearic, chumvi zao na esta, na anhidridi asetiki).",
    subProduct26: "3823 11 Asidi ya Stearic, viwandani",
    subProduct27: "3823 12 Oleic asidi, viwanda",
    subProduct28:
      "3823 19 asidi ya mafuta ya viwandani ya monocarboxylic; mafuta ya asidi kutoka kwa kusafisha (ukiondoa asidi ya stearic, asidi ya oleic na asidi ya mafuta ya mafuta marefu)",
    subProduct29: "3823 70 Pombe za mafuta za viwandani",
    subProduct30:
      "4001 Mpira wa asili, balata, gutta-percha, guayule, chicle na ufizi wa asili sawa, katika fomu za msingi au katika sahani, karatasi au strip",
    subProduct31:
      "4005 Mpira uliochanganywa, usiovuliwa, katika fomu za msingi au katika sahani, karatasi au strip",
    subProduct32:
      "4006 Raba isiyovumbuliwa katika aina zingine (k.m. vijiti, mirija na maumbo ya wasifu) na makala (k.m. diski na pete)",
    subProduct33: "4007 Uzi wa mpira wa vulcanized na kamba",
    subProduct34:
      "4008 Sahani, shuka, vipande, vijiti na maumbo ya wasifu, ya mpira uliovuliwa zaidi ya mpira mgumu.",
    subProduct35:
      "4010 mikanda ya usafirishaji au mikanda, ya mpira uliovuliwa",
    subProduct36: "4011 Matairi mapya ya nyumatiki, ya mpira",
    subProduct37:
      "4012 Matairi ya nyumatiki yaliyosomwa tena au yaliyotumika ya mpira; matairi madhubuti au ya mto, kukanyaga kwa matairi na mikunjo ya tairi, ya mpira",
    subProduct38: "4013 mirija ya ndani, ya mpira",
    subProduct39:
      "4015 Nakala za vifaa vya nguo na nguo (ikiwa ni pamoja na glavu, mittens na mitts), kwa madhumuni yote, ya mpira vulcanized zaidi ya mpira ngumu.",
    subProduct40:
      "4016 Vipengee vingine vya mpira vulcanized zaidi ya mpira ngumu, si mahali pengine maalum katika sura ya 40",
    subProduct41:
      "4017 Raba ngumu (k.m. ebonite) katika aina zote ikiwa ni pamoja na taka na chakavu; makala ya mpira ngumu",
    subProduct42: "1201 Maharage ya soya, yawe yamevunjwa au la",
    subProduct43: "1208 10 Unga wa maharagwe ya soya na unga",
    subProduct44:
      "1507 Mafuta ya maharagwe ya soya na sehemu zake, iwe imesafishwa au la, lakini haijabadilishwa kemikali.",
    subProduct45:
      "2304 Keki ya mafuta na mabaki mengine dhabiti, yawe yamesagwa au yasiongezwe au kwa namna ya pellets, yanayotokana na uchimbaji wa mafuta ya soya-maharage.",
    subProduct46:
      "4401 Mbao ya mafuta, katika magogo, katika billets, katika matawi, katika fagots au kwa namna sawa; mbao katika chips au chembe; machujo ya mbao na takataka za mbao na chakavu, yawe yamekusanyika au la katika magogo, briketi, pellets au aina zinazofanana.",
    subProduct47:
      "4402 Mkaa wa kuni (pamoja na ganda au mkaa wa kokwa), yawe yamechanganywa au la",
    subProduct48:
      "4403 Mbao kwenye mti mbaya, iwe imetolewa au haijavuliwa gome au mti wa msonobari, au yenye takribani mraba",
    subProduct49:
      "4404 Hoopwood; miti iliyogawanyika; mirundo, vijiti na vigingi vya mbao, vilivyochongoka lakini visivyokatwa kwa msumeno kwa urefu; vijiti vya mbao, vilivyopunguzwa takribani lakini havijageuzwa, kupindishwa au kufanyiwa kazi vinginevyo, vinafaa kwa ajili ya utengenezaji wa vijiti vya kutembea, miavuli, vipini vya zana au kadhalika; chipwood na kadhalika",
    subProduct50: "4405 Pamba ya mbao; unga wa mbao",
    subProduct51: "4406 Reli au tramway sleepers (misalaba) ya mbao",
    subProduct52:
      "4407 Mbao iliyokatwa au iliyokatwa kwa urefu, iliyokatwa au iliyovuliwa, iwe imepangwa au haijapangwa, iliyotiwa mchanga au iliyounganishwa mwisho, ya unene unaozidi 6 mm.",
    subProduct53:
      "Karatasi 4408 za kupamba (pamoja na zile zilizopatikana kwa kukata mbao zilizochongwa), kwa ajili ya plywood au kwa mbao zingine zinazofanana na laminated na mbao zingine, zilizokatwa kwa urefu, zilizokatwa au kumenya, iwe zimepangwa au hazijapangwa, zimepakwa mchanga, zimegawanywa au zimeunganishwa mwisho, za unene usio na kipimo. zaidi ya 6 mm",
    subProduct54:
      "4409 Mbao (pamoja na vipande na vikaangio kwa ajili ya sakafu ya parquet, zisizokusanywa) zenye umbo endelevu (zilizo na ulimi, zilizochongwa, zilizopigwa, zilizopigwa, zilizounganishwa kwa V, zilizo na shanga, zilizofinyangwa, zenye mviringo au kadhalika) kando ya kingo zake, ncha au nyuso zake, iwe au haijapangwa, kupigwa mchanga au kuunganishwa mwisho",
    subProduct55:
      "4410 Ubao wa chembe, ubao ulioelekezwa (OSB) na ubao sawa (kwa mfano, ubao wa kawi) wa mbao au nyenzo zingine zenye laini, iwe zimeunganishwa au la pamoja na resini au vitu vingine vya kikaboni vinavyofunga.",
    subProduct56:
      "4411 Fibreboard ya mbao au vifaa vingine vya laini, iwe imeunganishwa au haijaunganishwa na resini au vitu vingine vya kikaboni.",
    subProduct57: "4412 Plywood, paneli za veneered na mbao sawa laminated",
    subProduct58:
      "4413 Mbao zilizoimarishwa, katika vitalu, sahani, vipande au maumbo ya wasifu",
    subProduct59: "4414 Muafaka wa mbao kwa uchoraji, picha, vioo au vitu sawa",
    subProduct60:
      "4415 Kesi za kufunga, masanduku, makreti, ngoma na vifungashio sawa, vya mbao; cable-ngoma za mbao; pallets, pallets za sanduku na bodi nyingine za mizigo, za mbao;",
    subProduct61:
      "kola za mbao (bila kujumuisha nyenzo za kufunga zinazotumika kama nyenzo ya kupakia pekee ili kusaidia, kulinda au kubeba bidhaa nyingine iliyowekwa sokoni)",
    subProduct62:
      "4416 Madumu, mapipa, mapipa, beseni na bidhaa zingine za coopers na sehemu zake, za mbao, pamoja na fimbo.",
    subProduct63:
      "4417 Zana, vyombo vya zana, vipini vya zana, miili ya ufagio au brashi na vipini, vya mbao; buti au kiatu hudumu na miti, ya mbao",
    subProduct64:
      "4418 Viunga vya wajenzi na useremala wa mbao, pamoja na paneli za mbao za rununu, paneli za sakafu zilizokusanyika, shingles na mitikisiko.",
    subProduct65: "4419 Vyombo vya meza na jikoni, vya mbao",
    subProduct66:
      "4420 Maegesho ya mbao na mbao zilizopambwa; caskets na kesi kwa ajili ya vito au cutlery, na makala sawa, ya mbao; sanamu na mapambo mengine, ya mbao; Nakala za mbao za fanicha zisizoanguka katika Sura ya 94",
    subProduct67: "4421 Nakala zingine za mbao",
    subProduct68:
      "Majimaji na karatasi ya Sura ya 47 na 48 ya Nomenclature Mchanganyiko, isipokuwa bidhaa za mianzi na zilizopatikana (taka na chakavu).",
    subProduct69:
      "49 Vitabu vilivyochapishwa, magazeti, picha na bidhaa zingine za tasnia ya uchapishaji, maandishi, maandishi na mipango, ya karatasi.",
    subProduct70:
      "Viti 9401 (zaidi ya vile vya kichwa 9402 ), kiwe vitanda au sehemu zake, za mbao.",
    subProduct71:
      "9403 30 , 9403 40 , 9403 50 , 9403 60 na 9403 91 Samani za mbao na sehemu zake",
    subProduct72: "9406 10 Majengo yaliyotengenezwa kwa mbao",

    selectStatus: "Chagua Hali",

    pleaseSelectAtLeastOneSource: "Tafadhali chagua angalau chanzo kimoja.",
    invalidFileFormatPleaseUploadValidFile:
      "Umbizo la faili si sahihi. Tafadhali pakia faili la .xml, .kml, au .geojson.",
    pleaseUploadAValidFile: "Tafadhali pakia faili sahihi.",
    fileUploadedDuccessfully: "Faili limepakiwa kwa mafanikio!",
    anErrorOccured: "Kosa limetokea.",
    successfullyUpdatedDefaultFarmArea:
      "Eneo la shamba la chaguo-msingi limesasishwa kwa mafanikio.",
    pleaseAddProductionPlacesData:
      "Tafadhali ongeza data za Sehemu za Uzalishaji.",
    failedToFetchSettings: "Imeshindikana kupata mipangilio.",
    updatedDueDiligenceReport: "Ripoti ya bidii iliyosasishwa.",
    updatedDueDiligenceStatus:
      "Hali ya Uhakiki wa Kina imesasishwa kwa mafanikio.",
    failedToWriteDeforestationDataToBlockchain:
      "Imeshindikana kuandika data za ukataji miti kwenye blockchain, tafadhali jaribu tena.",
    countryIsRequired: "Nchi inahitajika",
    dueDiligenceReportsInfo:
      "Hati za kina zinazoelezea matokeo ya mchakato wa uangalizi wa kina. Ripoti hizi hutoa ufahamu wa tathmini iliyofanywa, ikiwa kuna hatari yoyote iliyotambuliwa, hali ya kufuata, na mapendekezo ya kupunguza au kuboresha.",
    listOfFarmsTT:
      "Onyesha kwa kina mashamba, ikiwa ni pamoja na habari kama eneo la uzalishaji, jina la mtayarishaji, nchi ya uendeshaji, eneo la ardhi katika ekari, aina ya shughuli za kilimo, tathmini zinazohusiana na ukataji miti, na tathmini ya hatari inayowezekana inayohusiana na shughuli za shamba.",
    loadingPleaseWait: "Inapakia... Tafadhali subiri",
    existingProductionPlacesTT:
      "Inaonyesha orodha ya maeneo ya uzalishaji yaliyopo pamoja na maelezo kama jina la mtayarishaji, nchi, eneo, aina, na hali ya tathmini.",
    successfullyGeneratedEUDRDeforestationStatus:
      "Hali ya ukataji miti ya EUDR imezalishwa kwa mafanikio.",
    riskAssessmentAndMitigationTT:
      "Kutambua hatari zinazowezekana na kutekeleza mikakati ya kupunguza athari zao au uwezekano wa kutokea. Inajumuisha kutathmini hatari, kuchambua matokeo yake yanayowezekana, na kuunda mipango ya kuzishughulikia au kuzidhibiti kwa ufanisi.",
    eudrRefNoTT:
      "Kitambulisho cha kipekee kilichotolewa kwa kila ripoti ya uangalizi, kinachorahisisha ufuatiliaji na uthibitishaji wa ufuasi ndani ya mfumo wa Udhibiti wa Ukataji Miti wa Umoja wa Ulaya (EUDR).",

    supplierDataTT: "Taarifa kuhusu msambazaji.",
    operatorDataTT: "Taarifa kuhusu mwendeshaji.",
    reportSummaryTT: "Muhtasari mfupi wa ripoti.",
    totalNoOfGeofencePolygon: "Jumla ya Idadi ya Poligoni za Geocerce",
    totalNoOfGeofencePolygonTT: "Jumla ya idadi ya poligoni za geocerce.",
    totalNoOfGeofencePoint: "Jumla ya Idadi ya Pointi za Geocerce",
    totalNoOfGeofencePointTT: "Jumla ya idadi ya pointi za geocerce.",
    totalNoOfFarmsTT: "Jumla ya idadi ya mashamba.",
    totalAreaFinalReport: "Jumla ya Eneo (ha)",
    totalNoOfDeforestationTT: "Jumla ya idadi ya tathmini za ukataji miti.",
    totalNoOfHighDeforestationTT:
      "Jumla ya mashamba yenye ukataji miti mkubwa.",
    totalNoOfRiskAssessments: "Jumla ya Tathmini za Hatari",
    totalNoOfRiskAssessmentsTT: "Jumla ya tathmini za hatari.",
    productDetail: "Maelezo ya Bidhaa",
    productDetailTT: "Taarifa kuhusu bidhaa.",
    productTT:
      "Jina la bidhaa. Inahusu kipengee kinachoshikika au mali inayozalishwa, kutengenezwa au kuuzwa na kampuni au shirika, mara nyingi imegawanywa kulingana na aina, sifa au kusudi lake.",
    productDescription: "Maelezo ya Bidhaa",
    productDescriptionTT:
      "Inatoa maelezo ya maandishi au muhtasari wa sifa, kazi au sifa za bidhaa, kwa lengo la kuwafahamisha watumiaji au wateja kuhusu asili au utendaji wake.",
    netMass: "Uzito Halisi",
    netMassTT:
      "Inaonyesha uzito wa bidhaa au kipengee, kwa kawaida huondoa uzito wa ufungaji au vifaa vingine vinavyohusiana, mara nyingi huonyeshwa kwa vitengo vya uzito kama vile kilogramu au pauni.",
    volume: "Kiasi",
    volumeTT:
      "Inahusu kiasi cha nafasi kinachochukuliwa na bidhaa au dutu, kwa kawaida hupimwa kwa vitengo vya ujazo kama mita za ujazo au futi za ujazo, kutumika kupima uwezo au wingi katika nafasi ya vipimo vitatu.",
    scientificName: "Jina la Kisayansi",
    scientificNameTT:
      "Jina la kitalaam la kiumbe linalojumuisha jenasi na spishi, mfano Coffea Arabica, Theobroma cacao L.",
    commonNameTT:
      "Jina lililo kwenye lugha ya kawaida ya maisha ya kila siku, mfano Kakao, Kahawa.",
    successfullyUploadedToTheBlockchain:
      "Mafanikio! Ripoti ya Uangalizi wa Uadilifu wa EUDR imepakiwa kwa mafanikio kwenye Blockchain.",
    complianceRiskWarning: "Onyo la Hatari ya Uzingatiaji",
    issueIdentifiedOnFarms:
      "Shida zimebainishwa kwenye baadhi ya mashamba ambazo zinahitaji kushughulikiwa kabla ya kuendelea na hatua inayofuata. Unaweza kuchagua kuzitatua sasa au kuendelea na hatua inayofuata na kuzitatua baadaye.",
    blockchainDescs: [
      "Inapakia ripoti kwenye blockchain, tafadhali subiri...",
      "Ripoti yako ya Uchunguzi wa Sababu inapakuliwa kwenye blockchain. Utapelekwa kwenye orodha ya Ripoti za Uchunguzi wa Sababu kuona hali hiyo.",
    ],
    reportDownloadedSuccessfully: "Ripoti imepakuliwa kwa mafanikio!",
    operatorDecleration: "Taarifa ya Opereta",
    supplierDecleration: "Taarifa ya Mtoaji",
    fRinternalReferenceNumberTT:
      "Nambari ya rejea ya ndani ni kitambulisho cha kipekee kilichotolewa kwa ripoti ya uchunguzi wa sababu ndani ya mfumo.",
    deleteProductionPlaceData: "Futa Data ya Mahali ya Uzalishaji",
    areYouSureYouWantToContinueThisAction:
      "Je, una uhakika unataka kuendelea na hatua hii?",
    noAssessment: "Hakuna tathmini",
    operatorDeclerationTT: "Taarifa ya tamko la mwendeshaji.",
    supplierDeclerationTT: "Taarifa ya tamko na msambazaji.",

    riskAssessmentNotApproved: "maeneo ya uzalishaji hayajaidhinishwa.",

    totalNoOfDeforestation: "Jumla ya Idadi ya Ukataji wa Misitu",

    blockchainVerification: "Uthibitishaji wa Blockchain",
    scanQrBlockchain:
      "Changanua msimbo huu wa QR ili kuona Ripoti ya Diligence ya EUDR kwenye blockchain.",
    downloadQrCode: "Pakua Msimbo wa QR",
    eudrPublicReport: "Ripoti ya Umma ya Dimitra EUDR kutokana na Diligence",
    scanQrEudr:
      "Changanua msimbo huu wa QR ili kuona Ripoti ya Diligence ya EUDR kwenye wavuti ya umma.",
    viewReportForPublic: "Bofya Hapa Kutazama Ripoti kwa Umma",
    viewReportOnBlockChain: "Bofya Hapa Kutazama Ripoti kwenye Blockchain",
    read: "Soma",
    unread: "Haujasomwa",
    all: "Zote",

    declarationMissing: "Tamko Linakosekana",
    removeRiskFarms: "ONDOA MASHAMBA YA HATARI",
    disregardRiskDocument: "PUUZIA MASHAMBA YA HATARI",
    attachRiskMitigationDocumentForNonCompliantFarms: "AMBATISHA HATI YA UPUNGUZAJI HATARI KWA MASHAMBA YOTE YASIYOZINGATIA",
    uploadMitigationDocumentForNonCompliantFarms: `Kupakia hati ya upunguzaji hatari kwa mashamba yote yasiyozingatia kutabadilisha hali ya mashamba yenye "Inahitaji Upunguzaji" kuwa "Imepunguzwa Kimaendeleo".`,
    disregardFarmWithIssuesTitle: "Puuza Shamba",
    disregardFarmWithIssuesMessage: "Kwa kuchagua 'Puuza,' hali ya tathmini ya hatari inayokosekana kwa mashamba haitazingatiwa katika ripoti hii. Mashamba yatabaki kuwa sehemu ya ripoti, lakini tathmini zao zinazosubiri hazitaathiri hali ya kufuata. Tafadhali thibitisha kwamba unataka kuendelea.",
    removeRiskFarmTitle: "Ondoa Shamba",
    removeRiskFarmMessage: "Kwa kuchagua 'Ondoa,' mashamba yenye tathmini za hatari zinazokosekana yataondolewa kwenye ripoti. Tafadhali thibitisha kwamba unataka kuendelea.",

    fileName: "Jina la faili",
    dateAndTime: "Tarehe na muda",
    downloadProgressStatus: "Hali ya maendeleo ya kupakua",
    downloadHistory: "Historia ya kupakua",
    downloaded: "Imepakuliwa",
    inprogress: "Inaendelea",
    failed: "Imeshindwa",
    showAllDownloads: "Onyesha pakua zote",
    inProgress: "Inaendelea",
    downloadCompleted: "Upakuaji umekamilika",
    downloadFailed: "Upakuaji umeshindwa",
    errorDeletingItem: "Haiwezekani kufuta kipengee. Tafadhali jaribu tena baadaye.",
    anErrorOccuredPlsTryAgain: "Tatizo limetokea. Tafadhali jaribu tena.",
    invalidData: "Taarifa zilizotolewa si sahihi. Tafadhali hakikisha na ujaribu tena.",
    fileIsReady: "Faili liko tayari kutumika",
    invalidFilePathOrUrl: "Njia au URL ya faili si sahihi.",
    errorDownloadingFile: "Kulikuwa na tatizo wakati wa kupakua faili. Tafadhali jaribu tena.",
    downloadInitiated: "Upakuaji umeanza",
    beingDownloaded: "inapakuliwa sasa. Muda unaokadiriwa",

    multiStepSurveyDetails: "Kulingana na idadi ya maswali katika hatua moja, maswali yote katika utafiti yatawekwa kwenye makundi na kuonyeshwa kwa hatua. Hata hivyo, usanidi huu unapatikana tu kabla ya kuongeza maswali au vichwa vidogo. Mara tu swali au kichwa kidogo kinapoongezwa, usanidi wa Hatua Nyingi utazimwa kiotomatiki. Tafadhali ondoa maswali yoyote au vichwa vidogo ili kuwezesha tena chaguo hili.",
    estimatedTime: "Muda wa makadirio",
    tryAgain: "Jaribu tena",
    iyb: {
      importSpreadsheetTitle: "Ingiza lahajedwali la alama za IYB",
      uploadFile: "Pakia faili",
      previewData: "Hakiki data",
      confirmImport: "Thibitisha uingizaji",
      uploadPtsiSpreadsheet: "Pakia lahajedwali la PTSI",
      uploadDescription: "Pakia lahajedwali la IYBv2 BOGOR lililotolewa na PTSI. Faili hili lina hali ya hatari ya EUDR na alama 13 za viashiria kwa regency 514 za Indonesia.",
      acceptedFormats: "Miundo inayokubalika",
      or: "au",
      clickOrDragFileHere: "Bofya au buruta na udondoshe faili la IYBv2 BOGOR hapa",
      acceptsCsvOrXlsx: "Inakubali .csv au .xlsx",
      dataYear: "Mwaka wa data",
      selectYearHint: "Chagua mwaka unaowakilishwa na data hii ya IYB. Data ya miaka iliyopita itahifadhiwa.",
      previewImportData: "Hakiki data ya uingizaji",
      showingRows: "Inaonyesha mistari {from} - {to}",
      totalRegenciesFound: "Jumla ya regency zilizopatikana",
      records: "rekodi",
      firePreventionTooltip: "Moto wa Misitu na Ardhi (IYBv2 BOGOR ind2). Kwa Mafuta ya Mawese: Nyekundu (≤40) huzuia uwasilishaji wa DDS.",
      lowRiskFastTrack: "Hatari ndogo → KIJANI (njia ya haraka)",
      mediumRiskMitigation: "Hatari ya kati → NJANO (upunguzaji)",
      highRiskAppealPath: "Hatari kubwa → NYEKUNDU (njia ya rufaa)",
      proceedToConfirm: "Endelea kuthibitisha",
      confirmImportDescription: "Uingizaji utaongeza au kusasisha alama za IYB kwa regency {total} kwa mwaka {year}. Alama za miaka mingine hazitaathiriwa.",
      totalRegencies: "Jumla ya regency",
      importNow: "Ingiza sasa",
      regencyId: "Kitambulisho cha regency",
      regencyName: "Jina la regency",
      iybScore: "Alama ya IYB",
      firePrevention: "Kuzuia moto",
      eudrRiskStatus: "Hali ya hatari ya EUDR",
      iybScores: "Alama za IYB",
      importSpreadsheet: "Ingiza lahajedwali",
      noDataFound: "Hakuna data iliyopatikana",
      noValidRegencyRows: "Lahajedwali halikuwa na mistari halali ya regency.",
      previewFailed: "Hakiki imeshindwa",
      couldNotParseSpreadsheet: "Haikuweza kuchakata lahajedwali",
      couldNotLoadPreviewPage: "Haikuweza kupakia ukurasa wa hakiki",
      importSuccessTitle: "Alama za IYB zimeingizwa kwa mafanikio",
      regenciesImported: "Regency {count} zimeingizwa",
      importFailed: "Uingizaji umeshindwa",
      couldNotImportSpreadsheet: "Haikuweza kuingiza lahajedwali",
      iybRegionalScores: "Alama za kikanda za IYB",
      iybRegionalScoresSubtitle: "Alama za viashiria vya uendelevu kwa ngazi ya regency kutoka PTSI. Hutumika kwa Awamu ya 2 ya ukaguzi wa utiifu wa EUDR Traffic Light.",
      allIndonesiaDistricts: "Wilaya zote za Indonesia",
      greenLowRisk: "KIJANI — Hatari ndogo",
      fastTrackEligible: "Inafaa kwa njia ya haraka",
      yellowMediumRisk: "NJANO — Hatari ya kati",
      mitigationRequired: "Upunguzaji unahitajika",
      redHighRisk: "NYEKUNDU — Hatari kubwa",
      blockedAppealPath: "Imefungwa, njia ya rufaa inapatikana",
      searchRegencyName: "Tafuta jina la regency...",
      filterByTier: "Chuja kwa kiwango",
      year: "Mwaka",
      details: "Maelezo",
      failedToLoadScores: "Imeshindwa kupakia alama za IYB",
      indicatorBreakdownTitle: "Mgawanyo wa viashiria vya IYB",
      regencyKabupaten: "Regency / Kabupaten",
      environmental: "Mazingira",
      socialAgricultural: "Kijamii na Kilimo",
      governance: "Utawala",
      scoreRanges: "Viwango vya alama:",
      lowRiskRange: "Hatari ndogo (≥60)",
      mediumRiskRange: "Hatari ya kati (40.01–59.99)",
      highRiskRange: "Hatari kubwa (≤40)",
      indicators: {
        spatialPlanning: "Mipango ya matumizi ya ardhi",
        forestLandFires: "Moto wa misitu na ardhi",
        waterWaste: "Maji na taka",
        climateAction: "Hatua za tabianchi",
        landExploitation: "Unyonyaji wa ardhi",
        independentSmallholders: "Wakulima wadogo huru",
        farmerInstitutions: "Taasisi za wakulima",
        businessPartnerships: "Ushirikiano wa biashara",
        indigenousCommunities: "Jamii za asili",
        gender: "Jinsia",
        spbeInformation: "Taarifa ya SPBE",
        sp4nLaporComplaints: "Malalamiko ya SP4N-LAPOR",
        fpicSop: "SOP ya FPIC",
      },
    }

  },
  diligenceGuide: {
    guide: "Mwongozo",
    downloadPdfManual: "Pakua Mwongozo wa PDF",
    watchDemoVideo: "Tazama Video ya Onyesho",
    viewManualOnWeb: "Tazama Mwongozo Kwenye Wavuti",
  },
  welcomeScreenDiligenceGuide: {
    title: "Kitovu Chako cha Mwongozo Muhimu",
    description: `Gundua ukurasa wetu wa Mwongozo wa Usaidizi wa Mfumo wa Uhakikisho wa Kina wa EUDR
          kwa rasilimali muhimu ikiwa ni pamoja na miongozo ya PDF, mafunzo ya video, na msaada wa wavuti.
          Jipa uwezo wa kuabiri jukwaa kwa ufanisi na kuboresha mtiririko wako wa kazi.`,
    continueToTheDueDiligenceSystem: "Endelea na Mfumo wa Uhakikisho wa Kina",
  },
  containerTypes: {
    standardDry: "Kontena Kavu la Kawaida (20ft, 40ft)",
    highCube: "Kontena la Urefu wa Juu",
    openTop: "Kontena la Juu Wazi",
    flatRack: "Kontena la Rafu Bapa",
    refrigerated: "Kontena la Jokofu (Reefer)",
    tank: "Kontena la Tanki",
    ventilated: "Kontena la Uingizaji Hewa",
    insulated: "Kontena la Kuhami",
    platform: "Kontena la Jukwaa",
    halfHeight: "Kontena la Nusu Urefu",
    bulk: "Kontena la Wingi",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Sammanfattning av Riskbedömning",
    riskAssessmentSummaryTT: "Sammanfattning av Riskbedömning",
    totalNoOfFarms: "Totalt Antal Gårdar",
    assessmentsCompleted: "Bedömningar Slutförda",
    assessmentsPending: "Bedömningar Pågående",
    requiredMitigation: "Krävda Åtgärder",
  }
};
